import { AppBar, Box, Accordion, AccordionSummary, Radio, FormControlLabel, AccordionDetails, useTheme, Menu, Toolbar, Table, ListItemIcon, ListItemText, TableHead, TableBody, Modal, TableContainer, TableRow, TableCell, Grid, Dialog, DialogActions, Button, Checkbox, Tooltip, Divider, MenuItem, Card, CardContent, TextField, Typography, FormControl, Stack, Chip, Autocomplete, Collapse, Alert, AlertTitle, IconButton, CardHeader, Breadcrumbs, emphasize, useMediaQuery, Pagination, DialogContent, CircularProgress, alpha } from "@mui/material";
import React, { useRef } from "react";
import Close from '@mui/icons-material/Close';
import Header from "../../../Layout/Header";

import EditIcon from '@mui/icons-material/Edit';
import ImportExportIcon from '@mui/icons-material/ImportExport';

import Searchicon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';

import ListAltIcon from '@mui/icons-material/ListAlt';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import RefreshIcon from '@mui/icons-material/Refresh';


import Report from '@mui/icons-material/Summarize';
import { useState, useEffect, useMemo } from "react";


import { tokens } from "../../../theme/theme";
import CallAlertBar from "../../../Layout/Alertbar";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded';

import qrcode from 'qrcode';
import { useTranslation } from "react-i18next";
import QualityCheckRejectProcee from "../qc/QCRejectReelProcess";
import LabelPalletDetails from "../labels/Pallet";

// date time concepts
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import GlobalConfig from "../../../config/date/GlobalConfig";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';



import ArticleIcon from '@mui/icons-material/Article';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
import InfoIcon from '@mui/icons-material/Info';
import { ExpandMore, ExpandLess, ArrowForward, ArrowForwardIos, ArrowForwardTwoTone, ArrowForwardIosRounded, DoubleArrowRounded, ArrowCircleRightOutlined } from '@mui/icons-material';
import ReelPendingConversionReport from "../reports/SheeterPendingConvertionReport";
import ReamBundlePendingConversionReport from "../reports/ReamBundlePendingConvertionReport";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import CustomTableContainer from "../../../components/table/CustomTableContainer";
import TableFilterRow from "../../../components/table/TableFilterRow";
import DeleteButton from "../../../components/DeleteButton";
import ReportSheeterProductionWIPPalletList from "../reports/ReportSheeterProductionWIPPalletList";
import AddRemarks from "../../master/AddRemarks";
import useRemarks from "../../../hooks/common/useRemarks";
dayjs.extend(customParseFormat);



const SheeterConvertionProcess = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    //  const [loading, setLoading] = useState(false);
    // sheeter Production details
    const [sheeterDateFrom, setSheeterDateFrom] = useState(dayjs);
    const [sheeterDateTo, setSheeterDateTo] = useState(dayjs);
    const [sheeterChildRoll, setSheeterChildRoll] = useState([]);
    const [sheeterSelectedChildRoll, setSheeterSelectedChildRoll] = useState(null);

    const [sheeterMONumber, setSheeterMONumber] = useState('');

    const [sheeterMANumber, setSheeterMANumber] = useState('');

    const [sheeterGSM, setSheeterGSM] = useState('');
    const [sheeterQuantity, setSheeterQuantity] = useState(0);

    const [sheeterShiftDate, setSheeterShiftDate] = useState(dayjs);

    const [sheeterPalletSize, setSheeterPalletSize] = useState('');
    const [sheeterPalletWeight, setSheeterPalletWeight] = useState(0);
    const [sheeterBalanceWeight, setSheeterBalanceWeight] = useState(0);
    const [sheeterTotalPallet, setSheeterTotalPallet] = useState(0);
    const [sheeterTotalLPallet, setSheeterTotalLPallet] = useState(0);

    const [sheeterNoOfSheets, setSheeterNoOfSheets] = useState(0);
    const [sheeterWidth, setSheeterWidth] = useState(0);
    const [sheeterLength, setSheeterLength] = useState(0);
    const [sheeterChildRollID, setSheeterChildRollID] = useState(0);
    const [sheeterMsgOpen, setSheeterMsgOpen] = useState(false);
    const [sheeterSeverityvalue, setSheeterSeverityvalue] = useState('info');
    const [sheeterMessageValue, setSheeterMessageValue] = useState('');
    const [sheeterAlertTitleValue, setSheeterAlertTitleValue] = useState('');

    const [viewSheeterchildRollDetail, setviewSheeterchildRollDetail] = useState(false);
    const [viewSheeterchildRollPlanningDetail, setviewSheeterchildRollPlanningDetail] = useState(false);
    const [viewSheeterchildRollSummaryDetail, setviewSheeterchildRollSummaryDetail] = useState(false);
    const [viewSheeterQRcode, setviewSheeterQRcode] = useState(false);

    // approved Child roll number list 
    const [approvedPalletNumber, setApprovedPalletNumber] = useState([]);
    const [selectedApprovedChildRollNumber, setSelectedApprovedChildRollNumber] = useState(null);
    const [palletList, setPalletList] = useState([]);

    const [selectedChildRollDetails, setSelectedChildRollDetails] = useState([]);

    // State for the QR code value
    const [qrCodeValue, setQRCodeValue] = useState('Netique infotech');



    const [errorMessage, setErrorMessage] = useState('');
    const [shiftdate_errorMessage, setshiftdate_errorMessage] = useState('');

    const [shiftCodes, setShiftCodes] = useState([]);
    const [winderOperators, setWinderOperators] = useState('');
    const [winderShiftCode, setWinderShiftCode] = useState('');
    const [winderShiftID, setWinderShiftID] = useState(0);
    const [winderShiftDate, setWinderShiftDate] = useState(dayjs());
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isDataLoadedCutter, setIsDataLoadedCutter] = useState(false);
    const [shiftDate, setShiftDate] = useState(dayjs());
    const [cutterCodes, setCutterCodes] = useState([]);
    const [selectedCutterCodes, setSelectedCutterCodes] = useState([]);

    const [disableProceedBtn, setDisableProceedBtn] = useState(false);
    const [disableNumberofSheets, setDisableNumberofSheets] = useState(false);
    const [period, setPeriod] = useState('Today');

    // focus 
    const selectchildrollRef = useRef(null);

    // reject reason
    const [rejectReason, setRejectReason] = useState([]);
    const [selectedReason, setSelectedReason] = useState([]);
    const [rejectProductType, setRejectProductType] = useState(null);
    const [rejectStatus, setRejectStatus] = useState(false);
    const [rejectReasonID, setRejectReasonID] = useState(0);
    const [rejectRemarks, setRejectRemarks] = useState(null);
    const [enableReject, setEnableReject] = useState(false);

    ///
    const [selectedPalletDetails, setSelectedPalletDetails] = useState([]);
    const [selectedButton, setSelectedButton] = useState(null);
    const [open, setOpen] = useState(false);
    const [getRejectResult, setGetRejectResult] = useState([]);

    // OPERATORS
    const [operator, setOperator] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState([]);
    const [selectedOperatorName, setSelectedOperatorName] = useState([]);
    const [isOperatorDataLoaded, setIsOperatorDataLoaded] = useState(false);


    const [enableReverseProcess, setEnableReverseProcess] = useState(true);
    const [autoPalletSheets, setAutoPalletSheets] = useState(0);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    const [FromShiftDate, setFromShiftDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToShiftDate, setToShiftDate] = useState(dayjs().format('DD/MMM/YYYY'));


    const [selectedMO, setSelectedMO] = useState('');
    const [showCard, setShowCard] = useState(false);
    const [childRollDetails, setChildRollDetails] = useState([]);
    const [partyList, setPartyList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [reelList, setReelList] = useState([]);
    const [viewReelList, setViewReelList] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedPalletRows, setSelectedPalletRows] = useState([]);
    const [selectedReelList, setSelectedReelList] = useState([]);
    const [viewChildRollProcess, setViewChildRollProcess] = useState(false);
    const [totalReelSheets, setTotalReelSheets] = useState(0);
    const [actualNoOfSheetsProduced, setActualNoOfSheetsProduced] = useState(0);
    const [loosepalletDet, setloosepalletDet] = useState([]);
    const [jobID, setJobID] = useState(0);
    const [disableSaveBtn, setDisableSaveBtn] = useState(false);
    const [summaryList, setSummaryList] = useState([]);
    const userPermissions = useUserPermissions();
    const [disableReelWiseSheetInput, setdisableReelWiseSheetInput] = useState(false);

    const [indentNo, setindentNo] = useState('');
    const [lineNo, setlineNo] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingOrderItemDet, setLoadingOrderItemDet] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page

    const [filterIndentno, setFilterIndentno] = useState('');
    const [indentNoList, setIndentNoList] = useState([]);
    const [fNo, setFNo] = useState(0);
    // Responsive breakpoints
    const isXs = useMediaQuery((theme) => theme.breakpoints.only("xs"));
    const isSm = useMediaQuery((theme) => theme.breakpoints.only("sm"));
    const isMd = useMediaQuery((theme) => theme.breakpoints.only("md"));
    const isLg = useMediaQuery((theme) => theme.breakpoints.only("lg"));
    const isXl = useMediaQuery((theme) => theme.breakpoints.only("xl"));

    // one object per reel, keyed by reel id
    const [reelFormData, setReelFormData] = useState({});

    // Correct State for showing WIP list
    const [openWIPListModal, setOpenWIPListModal] = useState(false);

    // remarks   
    const [openAddRemark, setOpenAddRemark] = useState(false);

    // dummy ids


    const moduledetails = userPermissions.find(
        (m) =>
            m.module_name === "Cutter Sheeter Convertion" &&
            m.parent_module_name === "Production"
    );

    const { remarkOptions, loadingRemarks, refetchRemarks } = useRemarks(moduledetails);


    // Handlers for AddRemarks dialog
    const handleOpenAddRemark = () => setOpenAddRemark(true);


    const handleCloseAddRemark = () => {
        setOpenAddRemark(false);
        refetchRemarks();
    };

    // Correct Handlers for the modal
    const handleOpenWIPListModal = () => {
        setOpenWIPListModal(true);
    };

    const handleCloseWIPListModal = () => {
        setOpenWIPListModal(false);
    };

    const handleBackSheeterMachineEntry = () => {
        setOpenWIPListModal(false);
    };
    useEffect(() => {
        setReelFormData(prev => {
            const next = [];

            selectedReelList.forEach((r, index) => {
                const existing = prev.find(p => p.id_reel === r.id_reel);

                next.push({
                    id_reel: r.id_reel,
                    sheetCount: existing?.sheetCount ?? r.sheetCount ?? "",
                    remarks: existing?.remarks ?? r.remarks ?? "",
                    repulp_qty: existing?.repulp_qty ?? r.repulp_qty ?? "",
                    grade: existing?.grade ?? r.grade ?? "",

                });
            });

            return next;
        });
    }, [selectedReelList]);


    const updateReelField = (reelId, field, value) => {
        setReelFormData(prev =>
            prev.map(item =>
                item.id_reel === reelId ? { ...item, [field]: value } : item
            )
        );
    };


    // Update recordsPerPage based on screen size
    useEffect(() => {
        if (isXs) setRecordsPerPage(4);
        else if (isSm) setRecordsPerPage(7);
        else if (isMd) setRecordsPerPage(9);
        else if (isLg) setRecordsPerPage(14);
        else if (isXl) setRecordsPerPage(24);
    }, [isXs, isSm, isMd, isLg, isXl]);



    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setShiftCodes(data);
                        setWinderShiftCode(data[0]);
                        setWinderShiftID(data[0].shiftid);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);

    useEffect(() => {
        if (!isDataLoadedCutter) {

            const para = {
                p_companyid: 58,
            }

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CUTTER_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setCutterCodes(data);
                        setSelectedCutterCodes(data[0]);
                        // setWinderShiftCode(data[0]);
                        // setWinderShiftID(data[0].shiftid);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoadedCutter]);


    const handleWinderShiftChange = (event, value) => {
        setWinderShiftCode(value);
        setWinderShiftID(value.shiftid);
    }

    useEffect(() => {
        if (!isOperatorDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setOperator(data);
                        setSelectedOperator(data[0]);
                        setSelectedOperatorName(data[0].operator_code);
                        setWinderOperators(data[0].operator_code);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isOperatorDataLoaded]);


    const handleOperatorChange = (event, value) => {
        setSelectedOperator(value);
        setSelectedOperatorName(value.operator_code);
        setWinderOperators(value.operator_code);
    }



    const handleSelectCuttercode = (event, value) => {
        setSelectedCutterCodes(value);
    }


    const CalculatePalletValue = (e) => {
        setSheeterNoOfSheets(e.target.value);
        if (e.target.value !== 0) {
            // calculatePallets(e.target.value);
            //calculatePallets_WithMoreParameter(e.target.value, actualNoOfSheetsProduced);

            UseLoosePalleteForCurrentProcess(e.target.value, checked, actualNoOfSheetsProduced, sheetCounts);

        }
    };

    const [isPalletCounted, setPalletCounted] = useState(false);

    useEffect(() => {
        if (!isPalletCounted) {
            if (sheeterLength !== 0 && sheeterWidth !== 0 && sheeterGSM !== 0) {
                calculatePallets(sheeterNoOfSheets);
                setPalletCounted(true);
            }
        }
    }, [sheeterLength, sheeterWidth, sheeterGSM]);


    // calculate pallets
    const calculatePallets = (sheets) => {
        if (sheets !== 0) {

            let palletwt = ((sheeterLength / 100) * (sheeterWidth / 100) * (sheeterGSM / 1000) * sheets);

            // Round palletwt to two decimal places
            palletwt = parseFloat(palletwt.toFixed(2));

            // const pallets = Math.floor((sheeterQuantity * 1000) / palletwt, 0);
            let pallets = 0;

            // let balanceSheets = (actualNoOfSheetsProduced - (pallets * sheets));  //changed actual reel produced (previous values : totalReelSheets)
            let balanceSheets = 0;
            let Balanceweight = 0;

            if (sheets > actualNoOfSheetsProduced) {
                balanceSheets = sheets - actualNoOfSheetsProduced;
            }
            else {
                pallets = Math.floor(actualNoOfSheetsProduced / sheets, 0);
                balanceSheets = (actualNoOfSheetsProduced - (pallets * sheets));
            }



            if (balanceSheets > 0) {
                setSheeterTotalLPallet(1);
                Balanceweight = ((sheeterLength / 100) * (sheeterWidth / 100) * (sheeterGSM / 1000) * balanceSheets);
                Balanceweight = parseFloat(Balanceweight.toFixed(2));
            }
            else {
                setSheeterTotalLPallet(0);
                Balanceweight = 0;
            }




            setSheeterPalletWeight(palletwt); // round up only two decimal
            setSheeterTotalPallet(pallets);
            setSheeterBalanceWeight(Balanceweight);// round up only two decimal
        }
    }

    const calculatePallets_WithMoreParameter = (sheets, actualNoOfSheetsProduced) => {
        if (sheets !== 0 && actualNoOfSheetsProduced > 0) {

            let palletwt = ((sheeterLength / 100) * (sheeterWidth / 100) * (sheeterGSM / 1000) * sheets);

            // Round palletwt to two decimal places
            palletwt = parseFloat(palletwt.toFixed(2));

            // const pallets = Math.floor((sheeterQuantity * 1000) / palletwt, 0);
            let pallets = 0;

            // let balanceSheets = (actualNoOfSheetsProduced - (pallets * sheets));  //changed actual reel produced (previous values : totalReelSheets)
            let balanceSheets = 0;
            let Balanceweight = 0;

            if (sheets > actualNoOfSheetsProduced) {
                balanceSheets = sheets - actualNoOfSheetsProduced;
            }
            else {
                pallets = Math.floor(actualNoOfSheetsProduced / sheets, 0);
                balanceSheets = (actualNoOfSheetsProduced - (pallets * sheets));
            }



            if (balanceSheets > 0) {
                setSheeterTotalLPallet(1);
                Balanceweight = ((sheeterLength / 100) * (sheeterWidth / 100) * (sheeterGSM / 1000) * balanceSheets);
                Balanceweight = parseFloat(Balanceweight.toFixed(2));
            }
            else {
                setSheeterTotalLPallet(0);
                Balanceweight = 0;
            }




            setSheeterPalletWeight(palletwt); // round up only two decimal
            setSheeterTotalPallet(pallets);
            setSheeterBalanceWeight(Balanceweight);// round up only two decimal
        }
        else {
            setSheeterTotalLPallet(0);
            setSheeterPalletWeight(0); // round up only two decimal
            setSheeterTotalPallet(0);
            setSheeterBalanceWeight(0);// round up only two decimal
        }



    }

    // Wrap callApi to handle HTTP errors in .then()
    const handleApiCall = async (endpoint, method, headers, body) => {
        try {
            return await callApi(endpoint, method, headers, body);
        } catch (error) {
            // Parse HTTP error response
            if (error.message.includes('HTTP Error! Status: 500')) {
                // Fetch again to get error details (since callApi throws)
                const response = await fetch(endpoint, {
                    method,
                    headers,
                    body: JSON.stringify(body)
                });
                const errorData = await response.json();

                // Return error object instead of throwing
                return {
                    status: 500,
                    error: true,
                    message: errorData.message || errorData.error || 'Server error',
                    data: errorData
                };
            }
            // Re-throw non-500 errors
            throw error;
        }
    };


    const updatePalletRollDetails = (mode) => {

        let isvalid = true;
        let validation_msg = '';

        // validation Process

        if (winderOperators === '') {
            validation_msg += 'Please Enter Sheeter Machine Operator.\n';
            isvalid = false;
        }

        if (sheeterNoOfSheets === 0) {
            validation_msg += 'Total Pallets Number of Sheets Value 0, Kindly enter no of sheets value.\n';
            isvalid = false;
        }

        // if (sheeterTotalPallet === 0) {
        //     validation_msg += 'Total Pallets Value 0.\n';
        //     isvalid = false;
        // }

        if (sheeterPalletWeight === 0) {
            validation_msg += 'Total Pallets Weight Value 0.\n';
            isvalid = false;
        }

        if (actualNoOfSheetsProduced === 0) {
            validation_msg += 'Please Enter the Total Produced Sheets.\n';
            isvalid = false;
        }

        const userID = localStorage.getItem('userID');
        if (!userID || userID === '0') {
            validation_msg += 'User session expired. Please login again..\n';
            isvalid = false;
        }

        // if (fNo === 0 || fNo === '') {
        //     validation_msg += 'Please Enter Finished No.\n';
        //     isvalid = false;
        // }

        // Remove trailing newline character if any
        validation_msg = validation_msg.trim();

        if (isvalid) {
            // Check if there is a loose pallet available
            if (loosepalletDet.length > 0) {
                if (!checked) {
                    const confirmation = window.confirm(
                        "Loose pallet available, you should assign produced sheets to that pallet. Please confirm."
                    );

                    if (confirmation) {
                        // Call the loose pallet function first
                        UseLoosePalleteForCurrentProcess(
                            sheeterNoOfSheets,
                            true, // Pass `event.target.checked` as true since the user accepted
                            actualNoOfSheetsProduced,
                            sheetCounts
                        );
                        setChecked(true);
                        return;
                    }
                    else {
                        //return;
                    }
                }

            }

            if (sheeterTotalPallet !== 0 || sheeterTotalPallet === 0) {

                let palletSize = `${sheeterWidth} X ${sheeterLength || 0} `;

                const parameter = {
                    // hdr part
                    p_shift_id: winderShiftID,
                    p_shift_date: dayjs(shiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_operator: selectedOperator.operator_code,
                    p_cutter_id: selectedCutterCodes.id,
                    p_transaction_id: 'none',
                    p_ref_no: 'sheet convertion',
                    p_break_status: false,
                    p_user: localStorage.getItem('userID'),
                    p_created_date: dayjs(sheeterShiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_modified_date: dayjs(sheeterShiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_company_id: localStorage.getItem('companyid'),
                    p_plant_id: 1,

                    // detail part
                    p_release_no: sheeterMONumber,
                    p_lot_no: sheeterMANumber,
                    p_achieved_qty: sheeterPalletWeight,
                    p_rejected_status: false,
                    p_det_remarks: '',
                    p_no_of_sheets: sheeterNoOfSheets,
                    p_balance_qty: sheeterBalanceWeight,

                    // pallet details

                    p_pallet_number_of_sheets: sheeterNoOfSheets,
                    p_pallet_weight: sheeterPalletWeight,
                    p_pallet_weight_unit: 'Kg',
                    p_pallet_reject_status: false,
                    p_pallet_size: palletSize,
                    p_pallet_winder_det_id: sheeterChildRollID,
                    p_pallet_count: sheeterTotalPallet,
                    p_process_id: 0,
                    p_selected_reel_list: selectedReelList,
                    p_pallet_lose_count: sheeterTotalLPallet,
                    p_total_sheets_in_reels: actualNoOfSheetsProduced, //changes actual sheets produced
                    p_sheet_produced_in_reels: sheetCounts,
                    p_exiting_loose_pallet_det: loosepalletDetTemp,
                    p_exiting_loose_pallet_shared_reel_det: allupdatedSheetDet.sheetsAllocated,
                    p_fno: fNo,
                    p_winder_details: reelFormData,
                    p_mode: mode, // 1 for update, 0 for create
                    p_id_job: jobID,
                }

                handleApiCall(API_ENDPOINTS.SHEETER_CONVERTION_UPDATE_PALLET_MULTI_REELS, 'POST', { 'Content-Type': 'application/json' }, parameter)
                    .then(response => {
                        // Check if response has error status first
                        if (response.error || (response.status && response.status !== 200)) {
                            // Shows InnerException!
                            setSheeterSeverityvalue('error');
                            setSheeterMessageValue(`Server Error: ${response.message}`);
                            setSheeterAlertTitleValue('Error Details');
                            setSheeterMsgOpen(true);
                            setviewSheeterchildRollSummaryDetail(false);
                            setEnableReverseProcess(true);
                            return;
                        }


                        // Success case - response is array of data
                        if (response && response.length > 0) {
                            setApprovedPalletNumber(response);
                            setViewReelList(false);
                            setviewSheeterQRcode(true);
                            setDisableProceedBtn(true);
                            setEnableReverseProcess(false);

                            if (mode === 0) {
                                toast.success('Pallets created successfully!', { position: toast.POSITION.BOTTOM_CENTER });
                            } else {
                                toast.success('Pallet Job updated successfully!', { position: toast.POSITION.BOTTOM_CENTER });
                            }

                            const paraPalletList = {
                                p_companyid: localStorage.getItem('companyid'),
                                p_plantid: 1,
                                p_mode: 1,
                                p_pallet_number: '',
                                p_child_reel_number: 0,
                                p_id_sheeter_hdr: response[0].id_sheeter_hdr
                            };

                            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_DETAILS, 'POST', { 'Content-Type': 'application/json' }, paraPalletList)
                                .then(pallets => {
                                    if (pallets && pallets.length > 0) {
                                        setPalletList(pallets);
                                    }
                                })
                                .catch(error => {
                                    console.error('Get pallet details error:', error);
                                });
                        } else {
                            if (selectedPallet.length === 0) {
                                setSheeterSeverityvalue('info');
                                setSheeterMessageValue('Unable Update Pallet Number.');
                                setSheeterAlertTitleValue('info');
                                setSheeterMsgOpen(true);
                                setviewSheeterchildRollSummaryDetail(false);
                                setEnableReverseProcess(true);
                            }
                        }
                    })
                    .catch(error => {
                        // Network errors or callApi failures
                        console.error('API call failed:', error);
                        setSheeterSeverityvalue('error');
                        setSheeterMessageValue(error.message || 'Network error. Please try again.');
                        setSheeterAlertTitleValue('Error');
                        setSheeterMsgOpen(true);
                        setviewSheeterchildRollSummaryDetail(false);
                        setEnableReverseProcess(true);
                    });


                // callApi(API_ENDPOINTS.SHEETER_CONVERTION_UPDATE_PALLET_MULTI_REELS, 'POST', { 'Content-Type': 'application/json' }, parameter)
                //     .then(data => {
                //         if (data && data.length > 0) {
                //             setApprovedPalletNumber(data);
                //             setViewReelList(false);
                //             // setviewSheeterchildRollDetail(false);
                //             setviewSheeterQRcode(true);
                //             setDisableProceedBtn(true);
                //             // Show a notification when the PDF is downloaded successfully

                //             setEnableReverseProcess(false);

                //             if (mode === 0) {
                //                 toast.success('Pallets created successfully!', { position: toast.POSITION.BOTTOM_CENTER });
                //             }
                //             else {
                //                 toast.success('Pallet Job updated successfully!', { position: toast.POSITION.BOTTOM_CENTER });
                //             }


                //             const paraPalletList = {
                //                 p_companyid: localStorage.getItem('companyid'),
                //                 p_plantid: 1,
                //                 p_mode: 1,
                //                 p_pallet_number: '',
                //                 p_child_reel_number: 0,
                //                 p_id_sheeter_hdr: data[0].id_sheeter_hdr
                //             };

                //             callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_DETAILS, 'POST', { 'Content-Type': 'application/json' }, paraPalletList)
                //                 .then(pallets => {
                //                     if (pallets && pallets.length > 0) {
                //                         setPalletList(pallets);

                //                     }
                //                 })
                //                 .catch(error => {
                //                     alert(error.message);
                //                 });
                //         }
                //         else {
                //             if (selectedPallet.length === 0) {
                //                 setSheeterSeverityvalue('info');
                //                 setSheeterMessageValue('Unable Update Pallet Number.');
                //                 setSheeterAlertTitleValue('info');
                //                 setSheeterMsgOpen(true);
                //                 setviewSheeterchildRollSummaryDetail(false);
                //                 setEnableReverseProcess(true);
                //             }

                //         }
                //     })
                //     .catch(error => {

                //         // Update state with error message        
                //         setSheeterSeverityvalue('error');
                //         setSheeterMessageValue(error.message);
                //         setSheeterAlertTitleValue('Error');
                //         setSheeterMsgOpen(true);
                //         setviewSheeterchildRollSummaryDetail(false);


                //     });
            }


        }
        else {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue(validation_msg);
            setSheeterAlertTitleValue('Error');
            setSheeterMsgOpen(true);
        }
    };

    const DeletePalletProductionJobDetails = () => {
        if (!hasPermission(userPermissions, "Cutter Sheeter Convertion", "Delete")) {
            alert("Access denied. You don’t have permission to delete this job.");
            return; // Exit the function if permission is not granted
        }

        const confirmDelete = window.confirm(`Are you sure you want to delete the entire job ${jobID}?`);

        if (confirmDelete) {
            if (jobID === 0) {
                setSheeterSeverityvalue('warning');
                setSheeterMessageValue('Please select the Job Details to delete.');
                setSheeterAlertTitleValue('Warning');
                setSheeterMsgOpen(true);
                return;
            }

            const parameter = {
                p_company_id: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_id_job: jobID,
                p_user: localStorage.getItem('userID'),
            };

            // create reams                   
            callApi(API_ENDPOINTS.SHEETER_DELETE_PALLET_PRODUCTION_JOB_DETAILS, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {

                        if (data[0].status === 'success') {

                            // LoadJobList();

                            // setviewReamProcess(false);
                            // setviewPalletList(true);
                            // setViewLineItemList(true);
                            LoadOrderList();

                            setSelectedChip('');
                            setViewJob(true);
                            setNewJob(false);

                            alert('Pallet Job Deleted successfully.')
                        }
                        else {
                            setSheeterSeverityvalue('warning');
                            setSheeterMessageValue(data[0].message);
                            setSheeterAlertTitleValue('Warning');
                            setSheeterMsgOpen(true);
                        }


                    }
                    else {
                        setSheeterSeverityvalue('error');
                        setSheeterMessageValue('Unable to delete the Pallet Job.');
                        setSheeterAlertTitleValue('Error');
                        setSheeterMsgOpen(true);
                    }
                })
                .catch(error => {
                    alert(error.message);
                    // Update state with error message        
                    setSheeterSeverityvalue('error');
                    setSheeterMessageValue(error.message);
                    setSheeterAlertTitleValue('Error');
                    setSheeterMsgOpen(true);

                });
        }


    }


    const ReversePalletRollDetails = () => {

        let isvalid = true;
        let validation_msg = '';

        // validation Process

        if (winderOperators === '') {
            validation_msg += 'Please Enter Sheeter Machine Operator.\n';
            isvalid = false;
        }

        if (sheeterNoOfSheets === 0) {
            validation_msg += 'Total Pallets Number of Sheets Value 0, Kindly enter no of sheets value.\n';
            isvalid = false;
        }

        if (sheeterTotalPallet === 0) {
            validation_msg += 'Total Pallets Value 0.\n';
            isvalid = false;
        }

        if (sheeterPalletWeight === 0) {
            validation_msg += 'Total Pallets Weight Value 0.\n';
            isvalid = false;
        }

        // Remove trailing newline character if any
        validation_msg = validation_msg.trim();

        if (isvalid) {



            if (sheeterTotalPallet !== 0) {

                const parameter = {
                    // hdr part
                    p_shift_id: winderShiftID,
                    p_shift_date: dayjs(sheeterShiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_operator: selectedOperator.operator_code,
                    p_cutter_id: selectedCutterCodes.id,
                    p_transaction_id: 'none',
                    p_ref_no: 'sheet convertion',
                    p_break_status: false,
                    p_user: localStorage.getItem('userID'),
                    p_created_date: dayjs(sheeterShiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_modified_date: dayjs(sheeterShiftDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_company_id: localStorage.getItem('companyid'),
                    p_plant_id: 1,

                    // detail part
                    p_release_no: sheeterMONumber,
                    p_lot_no: sheeterMANumber,
                    p_achieved_qty: sheeterPalletWeight,
                    p_rejected_status: false,
                    p_det_remarks: '',
                    p_no_of_sheets: sheeterNoOfSheets,
                    p_balance_qty: sheeterBalanceWeight,

                    // pallet details

                    p_pallet_number_of_sheets: sheeterNoOfSheets,
                    p_pallet_weight: sheeterPalletWeight,
                    p_pallet_weight_unit: 'Kg',
                    p_pallet_reject_status: false,
                    p_pallet_size: sheeterPalletSize,
                    p_pallet_winder_det_id: sheeterChildRollID,
                    p_pallet_count: sheeterTotalPallet,
                    p_process_id: 1

                }

                console.log('Send parameters for pallet', parameter);

                // call api for create pallet
                callApi(API_ENDPOINTS.SHEETER_CONVERTION_UPDATE_PALLET, 'POST', { 'Content-Type': 'application/json' }, parameter)
                    .then(data => {
                        if (data && data.length > 0) {
                            setApprovedPalletNumber(data);
                            setviewSheeterchildRollSummaryDetail(true);
                            setDisableProceedBtn(false);
                            setSelectedApprovedChildRollNumber(null);
                            setviewSheeterQRcode(false);
                            // Show a notification when the PDF is downloaded successfully
                            toast.success('Pallets Reversed successfully!', { position: toast.POSITION.BOTTOM_CENTER });

                        }
                        else {
                            setApprovedPalletNumber([]);
                            setviewSheeterchildRollSummaryDetail(false);
                            setDisableProceedBtn(false);
                            setSelectedApprovedChildRollNumber(null);
                            setviewSheeterQRcode(false);
                            // Show a notification when the PDF is downloaded successfully
                            toast.success('Pallets Reversed successfully!', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                    })
                    .catch(error => {
                        // Update state with error message        
                        setSheeterSeverityvalue('error');
                        setSheeterMessageValue(error.message);
                        setSheeterAlertTitleValue('Error');
                        setSheeterMsgOpen(true);
                        setviewSheeterchildRollSummaryDetail(false);
                    });
            }


        }
        else {
            setSheeterSeverityvalue('warning');
            setSheeterMessageValue(validation_msg);
            setSheeterAlertTitleValue('Error');
            setSheeterMsgOpen(true);
        }
    };

    const getPalletList = () => {

        const palletData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_child_roll_number: sheeterSelectedChildRoll.child_reel_number,
        };


        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_PALLET_DETAILS, 'POST', { 'Content-Type': 'application/json' }, palletData)
            .then(data => {
                if (data && data.length > 0) {
                    setApprovedPalletNumber(data);
                }
            })
            .catch(error => {
                alert(error.message);
            });

        const paraPalletList = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_mode: 1,
            p_pallet_number: '',
            p_child_reel_number: sheeterSelectedChildRoll.child_reel_number,
        };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_DETAILS, 'POST', { 'Content-Type': 'application/json' }, paraPalletList)
            .then(pallets => {
                if (pallets && pallets.length > 0) {
                    setPalletList(pallets);
                }
            })
            .catch(error => {
                alert(error.message);
            });

    };


    const callbacknewSheeterProcess = () => {
        setNewJob(false);
        setViewJob(true);
        LoadOrderList();

    };


    const filterData = (filter) => {
        let fromDate, toDate;
        switch (filter) {
            case 'All':
                fromDate = dayjs().subtract(4, 'year').startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'Today':
                fromDate = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Week':
                fromDate = dayjs().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('week').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Month':
                fromDate = dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Quarter':
                fromDate = dayjs().startOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('quarter').format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'This Year':
                fromDate = dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss');
                toDate = dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss');
                break;
            default:
                fromDate = ''; // You can set a default value here
                toDate = ''; // You can set a default value here
                break;
        }

        //setDateRange({ from: fromDate, to: toDate });

        // Date filter
        // Date filter
        const p_companyid = localStorage.getItem('companyid');
        const p_frommodate = fromDate;//dayjs(sheeterDateFrom).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = toDate;//dayjs(sheeterDateTo).format('YYYY-MM-DD hh:mm:ss');
        const p_filtertype = "sheet_process";
        const p_mono = 0;

        // Collect the values of the controls
        const parameter = {
            p_companyid,
            p_frommodate,
            p_tomodate,
            p_filtertype,
            p_mono,
        };

        //SHEETER_CONVERTION_GET_APROVED_ALL_CHILD_LIST
        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_REEL_WT_CONFIRMET_CHILDREELS, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setSheeterChildRoll(data);
                    setSheeterMsgOpen(false);
                    // Focus on the Autocomplete input after updating the data
                    // Check if ref exists before calling focus to avoid errors
                    if (selectchildrollRef.current) {
                        selectchildrollRef.current.focus();
                    }

                }
                // else {
                //     // No data found
                //     // setSheeterChildRoll(null);
                //     setSheeterSeverityvalue('info');
                //     setSheeterMessageValue('No Child roll found this date range (' + p_frommodate + ' - ' + p_tomodate + ")");
                //     setSheeterAlertTitleValue('info');
                //     setSheeterMsgOpen(true);

                // }
            })
            .catch(error => {
                // Update state with error message        
                setSheeterSeverityvalue('error');
                setSheeterMessageValue(error.message);
                setSheeterAlertTitleValue('Error');
                setSheeterMsgOpen(true);
            });



        setviewSheeterchildRollSummaryDetail(false);
        setviewSheeterchildRollDetail(false);
        setviewSheeterchildRollPlanningDetail(false);
        setSelectedApprovedChildRollNumber(null);
        setSheeterSelectedChildRoll(null);


    };



    const handleButtonClick = async (buttonName) => {

        setSelectedButton(buttonName);
        setSheeterMsgOpen(false);

        // let printselectedPalletDetails = approvedPalletNumber;
        let printselectedPalletDetails = palletList;
        let isvalid = true;

        if (printselectedPalletDetails.length === 0) {
            isvalid = false;
        } else if (buttonName === "PrintQR" && (!selectedPalletDetails || selectedPalletDetails.length === 0)) {
            isvalid = false;

            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select pallet code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
        }


        // filter data      
        printselectedPalletDetails = palletList.filter((pallet) => selectedPalletRows.includes(pallet.pallet_id));

        if (printselectedPalletDetails.length === 0) {
            isvalid = false;
            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select pallet code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
            return;
        }


        if (isvalid == true) {
            const printWindow = window.open('', '_blank');

            // if (buttonName === "PrintQR") {
            //     printselectedPalletDetails = selectedPalletDetails;
            //     printselectedPalletDetails = printselectedPalletDetails ? [printselectedPalletDetails] : []; // Wrap bundleDetails in an array if it exists
            // }

            try {
                // Generate HTML content for each QR code
                for (const qrCodeValue of printselectedPalletDetails) {

                    // Generate QR code data URL
                    const qrDataUrl = await generateQRCode(qrCodeValue.pallet_code);
                    // Check if QR code generation was successful

                    if (!qrDataUrl) {
                        console.error('Error generating QR code for value:', qrCodeValue.pallet_code);
                        continue; // Skip to the next QR code
                    }

                    // Write HTML content for the QR code to the print window
                    printWindow.document.write(`

               

                <html>
                    <head>
                        <title>Printed Report</title>
                        <style>
                                body {
                                    margin: 0;
                                    padding: 0;
                                    font-family: Arial, sans-serif;
                                }
                                .container {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    padding: 10px;
                                    border: 1px solid #ccc;
                                    box-sizing: border-box;
                                }
                                .qr-code {
                                    width: 150px; /* Adjust as needed */
                                }
                                .bundle-details {
                                    flex: 1;
                                    margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                                }
                                .bundle-details h5 {
                                    margin: 0;
                                    font-size: 18px;
                                }
                                .details-table {
                                    display: grid;
                                    grid-template-columns: 150px auto;
                                    gap: 10px 20px;
                                    margin-top: 10px;
                                }
                                .details-table div {
                                    font-size: 16px;
                                }
                                .details-table .label {
                                    font-weight: bold;
                                }
                                .bundle-details hr {
                                    margin: 10px 0;
                                    border: 1px solid #ccc;
                                }
                                /* Ensure each container goes on a new page */
                                .container {
                                    page-break-after: always;
                                }
                            </style>
                    </head>
                    <body>
                    <div class="container">
                    <div>
                        <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                        <h3>${qrCodeValue.pallet_code || 'XXXXXX0123'}</h3>
                    </div>
                    <div class="bundle-details">
                        <h5>PALLET DETAILS</h5>
                            <hr/>
                       <div class="details-table">
                            <div class="label">DATE / SHIFT </div><div>:  ${qrCodeValue.shift_date || ''} / ${qrCodeValue.shift_code || ''}</div> 
                            <div class="label">PALLET CODE</div><div>: ${qrCodeValue.pallet_code}</div> 
                            <div class="label">REEL NUMBER</div><div>: ${qrCodeValue.cr_number}</div> 
                            <div class="label">QUALITY</div><div>: ${qrCodeValue.item_code}</div> 
                            <div class="label">SIZE</div><div>: ${qrCodeValue.size}</div>  
                            <div class="label">GSM</div><div>: ${qrCodeValue.gsm}</div> 
                            <div class="label">PALLET WEIGHT (KG)</div><div>: ${qrCodeValue.pallet_weight}</div> 
                            <div class="label">NO.OF.SHEETS</div><div>: ${qrCodeValue.no_of_sheets}</div> 
                            <div class="label">MO NO</div><div>: ${qrCodeValue.release_no}</div> 
                            <div class="label">MA NO</div><div>: ${qrCodeValue.lot_no}</div> 
                            <div class="label">SO NO</div><div>: ${qrCodeValue.indent_no}</div> 
                             <div class="label">CUSTOMER NAME</div><div>: ${qrCodeValue.customer_name}</div> 
                            <div class="label">REMARKS</div><div>:</div>            
                        
                        </div>
                         
                    </div>
                      
                </div>
                    </body>
                </html>                
                    
                `);
                }

                // Close the print window and print the report
                printWindow.document.close();
                printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }

        }

    };

    const handlePrintReamQRCodeButtonClick = async (buttonName) => {
        setSelectedButton(buttonName);
        setSheeterMsgOpen(false);

        // let printselectedPalletDetails = approvedPalletNumber;
        let printselectedPalletDetails = palletList;
        let isvalid = true;

        if (printselectedPalletDetails.length === 0) {
            isvalid = false;
        } else if (buttonName === "PrintQR" && (!selectedPalletDetails || selectedPalletDetails.length === 0)) {
            isvalid = false;

            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select pallet code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
        }


        // filter data      
        printselectedPalletDetails = palletList.filter((pallet) => selectedPalletRows.includes(pallet.pallet_id));

        if (printselectedPalletDetails.length === 0) {
            isvalid = false;
            setSheeterSeverityvalue('info');
            setSheeterMessageValue('Please select pallet code to print. ');
            setSheeterAlertTitleValue('info');
            setSheeterMsgOpen(true);
            return;
        }


        if (isvalid === true) {
            const printWindow = window.open('', '_blank');

            // if (buttonName === "PrintQR") {
            //     printselectedPalletDetails = selectedPalletDetails;
            //     printselectedPalletDetails = printselectedPalletDetails ? [printselectedPalletDetails] : []; // Wrap bundleDetails in an array if it exists
            // }

            try {
                // Generate HTML content for each QR code
                for (const qrCodeValue of printselectedPalletDetails) {

                    const [width, length] = qrCodeValue.size.split(" X ").map(Number);

                    // Generate QR code data URL
                    const no_of_sheets = 100;
                    const reamcnt = Math.ceil(qrCodeValue.no_of_sheets / no_of_sheets);

                    let ream_weight = (qrCodeValue.gsm * width * length * no_of_sheets) / 10000000
                    ream_weight = Math.round(ream_weight * GlobalConfig.DecimalPointsReamWeight) / GlobalConfig.DecimalPointsReamWeight;



                    for (let i = 0; i < reamcnt; i++) {

                        const qrDataUrl = await generateQRCode(qrCodeValue.pallet_code);
                        // Check if QR code generation was successful

                        if (!qrDataUrl) {
                            console.error('Error generating QR code for value:', qrCodeValue.pallet_code);
                            continue; // Skip to the next QR code
                        }

                        // Write HTML content for the QR code to the print window
                        printWindow.document.write(`
                            <html>
                            <head>
                        <title>Printed Report</title>
                        <style>
                            @page {
                                 size: 100mm 25mm; /* Portrait orientation */
                                     margin: 0; /* Remove margins for edge-to-edge printing */
                            }
                            body {
                                margin: 0;
                                padding: 0;
                                font-family: Arial, sans-serif;
                                display: flex;
                                flex-wrap: wrap; /* Allows multiple labels on the same page */
                                align-items: flex-start;
                                justify-content: flex-start;
                                
                                box-sizing: border-box;
                            }
                            .container {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                width: 100%;
                                height: 45px;
                                padding: 0; /* Remove padding from the container */
                                box-sizing: border-box;
                            }
                            .labelx {
                                width: 100mm;
                                height: 25mm;
                                padding: 2mm; /* Adjust as needed for content alignment */
                                box-sizing: border-box;
                               
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                            }
                            .logo {
                                max-width: 7mm; /* Ensure logo scales within a small area */
                                height: auto;
                               
                            }
                            .text-details {
                                flex: 1;
                                margin-left: 1mm;
                                margin-top: 0.2mm;
                                font-size: 0.4rem;
                                font-weight: bold;
                            }
                            .text-details p {
                                margin: 0;
                                line-height: 1.1; /* Reduce line spacing for compactness */
                                font-weight: bold;
                                color: #01579b;
                            }
                            .marketed-by {
                                text-align: center;
                                font-size: 0.3rem;
                                font-weight: bold;
                                margin-top: 0.5mm; /* Reduce or remove space above */
                            }
                            .marketed-by p {
                                margin: 0; /* Remove margins from paragraphs */
                                line-height: 1.1; /* Compact line spacing */
                            }
                            .details-section {
                                display: grid;
                                grid-template-columns: auto auto; /* Label and value in two columns */
                                gap: 0.1mm 0.1mm; /* Reduce spacing between rows and columns */
                                width: 100%;                                   
                                margin-top: 0.5mm;
                                
                            }
                            .details-section .label {
                                font-weight: bold;
                                text-align: left;
                                 font-size: 0.7rem;
                            }
                           .details-section .label1 {                                    
                                text-align: left;
                                 font-weight: bold;
                                 font-size: 0.6rem;
                            }
                            .details-section .value {
                                text-align: left;
                                font-size: 0.7rem;
                            }
                            .details-section .value1 {
                                text-align: left;
                                font-size: 0.6rem;
                            }
                            .details-section .full-line {
                                text-align: left; /* Center align the text */
                                font-size: 0.9rem; /* Adjust font size for readability */
                                font-weight: bold; /* Bold text for emphasis */
                                text-transform: uppercase; /* Ensure the text is all caps */
                                width: 100%; /* Span the full width of the container */
                                grid-column: 1 / -1; /* Make it span across both columns in the grid */
                                margin-top: 0mm; /* Optional: Add spacing above for better layout */
                                white-space: nowrap; /* Prevent wrapping to a new line */
                            }    
                        </style>
                    </head>
                           <body>
                           <div class="labelx">
                           <div class="header-row" ">
                                        <!-- Logo -->
                                        <div class="container">
                                            <!-- Logo Section -->
                                            <div>
                                               
                                            </div>
    
                                            <!-- Text Details -->
                                            <div class="text-details">
                                               
                                            </div>
                                        </div>
    
                                        
                            
                                    <!-- Marketed By Section -->
                                    <div class="marketed-by">
                                        
                                    </div>
                          </div>


                     <!-- Details Section -->
                               <div>
                                    <table style="text-align: left; font-size: 10px; border-collapse: collapse;">
                                        <tr>
                                            <!-- Column 1 -->
                                            <th style="padding-right: 1px;">
                                                <table style="text-align: left; font-size: 10px;">
                                                    <tr>
                                                        <th>${qrCodeValue.item_code}</th>
                                                    </tr>
                                                    <tr>
                                                        <th>GSM:</th>
                                                        <th>${qrCodeValue.gsm}</th>
                                                    </tr>
                                                    <tr>
                                                        <th>SIZE(cm):</th>
                                                        <th>${qrCodeValue.size}</th>
                                                    </tr>
                                                    <tr>
                                                        <th>NET WT(kg):</th>
                                                        <th>${ream_weight}</th>
                                                    </tr>
                                                    <tr>
                                                        <th style="visibility: hidden;">F.NO:</th>
                                                        <th style="visibility: hidden;">${fNo || 0}</th>
                                                    </tr>
                                                </table>
                                            </th>

                                            <!-- Column 2 -->
                                            <th>
                                                <table style="text-align: left; font-size: 10px;">
                                                    <tr>
                                                        <th>DATE:</th>
                                                

                                                      <th>${formatDateNew(qrCodeValue.shift_date)}</th>
                                                      
                                                    </tr>
                                                    <tr>
                                                        <th>LOT NO:</th>
                                                        <th>${qrCodeValue.pr_number}</th>
                                                    </tr>
                                                    <tr>
                                                        <th></th>
                                                        <th>/ ${qrCodeValue.cr_number}</th>
                                                    </tr>
                                                    <tr>
                                                        <th>NO OF SHEET:</th>
                                                        <th> ${no_of_sheets || 0}</th>
                                                    </tr>
                                                    <tr style=" font-size: 12px;">
                                                        <th>MADE IN INDIA</th>
                                                    
                                                    </tr>
                                                
                                                </table>
                                            </th>
                                        </tr>
                                    </table>
                                </div> 
                                                                  
                                    
                               </div>
                            </body>
                            </html>
                            `);



                    }
                }








                // Close the print window and print the report
                printWindow.document.close();
                printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }

        }
    };



    const viewQRCode = async () => {
        const palletDetails1 = approvedPalletNumber.filter((pallet) => selectedPalletRows.includes(pallet.id));
        const palletDetails = palletList.filter((pallet) => selectedPalletRows.includes(pallet.pallet_id));
        setSelectedPalletDetails(palletDetails);
        setSelectedChildRollDetails(palletDetails1);
        setviewSheeterQRcode(true);
    };


    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        }).replace(/ /g, "-"); // Replace spaces with hyphens
    };
    const formatDateNew = (dateString) => {
        // if (!dateString) return "N/A";
        // const [day, month, year] = dateString.split("-"); // Split date by "-"
        // const date = new Date(`${year}-${month}-${day}`); // Rearrange to YYYY-MM-DD
        // return date.toLocaleDateString("en-GB", {
        //     day: "2-digit",
        //     month: "short",
        //     year: "numeric",
        // }).replace(/ /g, "-");
        if (!dateString) return "N/A";

        const isISOFormat = dateString.includes("T"); // Check if ISO format

        if (isISOFormat) {
            return dayjs(dateString).format("DD-MMM-YYYY");
        } else {
            return dayjs(dateString, "DD-MM-YYYY").format("DD-MMM-YYYY");
        }
    };



    const openpopup = async (buttonName) => {
        setSelectedButton(buttonName);

        if (buttonName == 'ReverseProcess') {
            ReversePalletRollDetails();
        }
        else if (buttonName == 'RejectChild') {
            setOpen(true);
        }
    }

    const closepopup = () => {

        setOpen(false);
        setSheeterMsgOpen(false);

        let reject_product_type = "Pallet";
        // let child_roll_number = selectedApprovedChildRollNumber.pallet_code;
        let product_code = selectedApprovedChildRollNumber.pallet_code;
        let isvalid = true;

        if (enableReject == false) {
            isvalid = false;
        }
        else if (product_code === "") {
            isvalid = false;
        }
        else if (selectedApprovedChildRollNumber.pallet_code == "") {
            isvalid = false;
        }
        else if (selectedPalletDetails.status != "approved") {

            isvalid = false;
            if (selectedPalletDetails.status == "rejected") {

                setSheeterSeverityvalue('info');
                setSheeterMessageValue('Pallet already rejected');
                setSheeterAlertTitleValue('info');
                setSheeterMsgOpen(true);
            }
            else {
                setSheeterSeverityvalue('info');
                setSheeterMessageValue('We cannot reject this pallet. The pallet has already been processed for the next stage.');
                setSheeterAlertTitleValue('info');
                setSheeterMsgOpen(true);
            }

        }


        if (isvalid) {
            // call reject reel process
            const parameter = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_reject_product_type: reject_product_type,
                p_product_code: product_code,
                p_rejectReasonID: rejectReasonID,
                p_rejectRemarks: rejectRemarks,
                p_user: localStorage.getItem('userID'),
            };

            callApi(API_ENDPOINTS.DECKL_UPDATE_REJECT_REEL, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        setGetRejectResult(data);
                        setSheeterSeverityvalue('info');
                        setSheeterMessageValue('The pallet has rejected.');
                        setSheeterAlertTitleValue('info');
                        setSheeterMsgOpen(true);
                        getPalletList();
                    }
                })
                .catch(error => {

                });
        }
    }




    const ChildRollCompleteDetails = async (child_roll_id) => {
        try {
            const para = { p_companyid: localStorage.getItem('companyid'), p_id_child_reel: child_roll_id, }
            const data = await callApi(API_ENDPOINTS.WAREHOUSE_GET_STACK_WISE_ALLOCATED_REEL_COMPLETE_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data && data.length > 0) {
                setChildRollDetails(data);
            }

        }
        catch (error) { alert(error); }

    };


    useEffect(() => {
        const fetchChildRollDetails = async () => { if (period === 'Today') { filterData('Today'); } };
        fetchChildRollDetails();
    }, [setPeriod]);


    // auto- number of sheets in pallet



    const handleHide = () => { setShowCard(false); };



    const handleFromShiftDateChange = (date) => {
        setFromShiftDate(dayjs(date));
    };

    const handleToShiftDateChange = (date) => {
        setToShiftDate(dayjs(date));
    };



    const [filters, setFilters] = useState({
        indent_no: '',
        cr_number: '',
        from_date: '',
        to_date: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };

    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    // filter data new concept

    useEffect(() => {
        // Date filter       
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate,
        };

        setLoading(true);
        setLoadingOrderItemDet(true);
        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setLoading(false);
                    setLoadingOrderItemDet(false);
                } else {
                    // No data found
                    setPartyList([]);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoading(false);
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });
    }, []);

    const LoadOrderLineItemDetailsWithOutFilter = () => {
        // Date filter       
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate,
        };

        setLoading(true);
        setLoadingOrderItemDet(true);
        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_DETAILS, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setLoading(false);
                    setLoadingOrderItemDet(false);
                    setSheeterMsgOpen(false);
                } else {
                    // No data found
                    setPartyList([]);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoading(false);
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });
    }


    const LoadOrderLineItemDetailsFIlterByCONumber = (CO_Number) => {

        // Date filter       
        const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
        const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');
        const p_mono = 0;
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_release_no: p_mono,
            p_frommodate,
            p_tomodate,
            p_indent_no: CO_Number
        };

        setLoading(true);
        setLoadingOrderItemDet(true);
        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_DETAILS_CONUMBER_FILTER, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyList(data);
                    setLoading(false);
                    setLoadingOrderItemDet(false);
                    setSheeterMsgOpen(false);
                } else {
                    // No data found
                    setPartyList([]);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                    setLoading(false);
                    setLoadingOrderItemDet(false);
                }
            })
            .catch(error => {
                // Update state with error message        
                callError('error', error.message, 'Error');
                setLoadingOrderItemDet(false);
            });

    }


    const callError = (serverityval, msg, title) => {
        // Update state with error message        
        setSheeterSeverityvalue(serverityval);
        setSheeterMessageValue(msg);
        setSheeterAlertTitleValue(title);
        setSheeterMsgOpen(true);
    };

    const handlecallEditJob = (jobID) => {
        if (!hasPermission(userPermissions, "Cutter Sheeter Convertion", "View")) {
            alert("Access denied. You don’t have permission to view this page.");

            return; // Exit the function if permission is not granted
        }

        setJobID(jobID);
        setviewSheeterchildRollDetail(true);
        setSelectedChip('View Sheeter Process');
        setViewJob(false);
        setNewJob(true);
        setDisabledLooseBundleOption(true);
        setChecked(false);
        setdisableReelWiseSheetInput(true);
        setActualNoOfSheetsProduced(0);
    }


    // get job header details    
    const [jobHDRDetails, setJobHDRDetails] = useState([]);
    const [updateshiftCode, setUpdateShiftCode] = useState('');
    const [updateOperator, setUpdateOperator] = useState('');
    const [updateCutterCode, setUpdateCutterCode] = useState(0);
    const [shiftCodeUpdate, setShiftCodeUpdate] = useState(false);
    const [operatorUpdate, setOperatorUpdate] = useState(false);
    const [cutterCodeUpdate, setCutterCodeUpdate] = useState(false);

    useEffect(() => {
        if (jobID <= 0) return;

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_job_number: jobID,
        };

        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_JOD_HDR_DETAIL_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data?.length) {
                    const [firstJob] = data;
                    setJobHDRDetails(data);
                    setSheeterNoOfSheets(firstJob.no_of_sheets);
                    setUpdateShiftCode(firstJob.shift_code);
                    setShiftCodeUpdate(false);
                    setUpdateOperator(firstJob.s_operator);
                    setOperatorUpdate(false);
                    // setWinderShiftDate(dayjs(firstJob.shift_date));
                    setShiftDate(dayjs(firstJob.shift_date));
                    setUpdateCutterCode(firstJob.id_cutter);
                    setCutterCodeUpdate(false);
                    setFNo(firstJob.fno);
                    // calculatePallets(firstJob.no_of_sheets);
                    calculatePallets_WithMoreParameter(firstJob.no_of_sheets, actualNoOfSheetsProduced);
                } else {
                    setJobHDRDetails([]);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                }
            })
            .catch(error => callError('error', error.message, 'Error'));
    }, [jobID]);

    useEffect(() => {
        if (jobID > 0) {

            const orderData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_job_number: jobID

            };
            callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_CHILD_REEL_LIST_USING_JOB_ID, 'POST', { 'Content-Type': 'application/json' }, orderData)
                .then(data => {
                    if (data && data.length > 0) {
                        setSelectedReelList(data);
                        RefreshSelectedChilddata(data);

                        // Extract id_reel and noofsheets, rename noofsheets to sheetCount
                        const newArray = data.map(({ id_reel, noofsheets }) => ({
                            id_reel,
                            sheetCount: noofsheets,
                        }));

                        setSheetCounts(newArray);
                    } else {
                        // No data found
                        setSelectedReelList([]);

                        callError('info', 'No data found, Kindly adjust data range.', 'info');
                    }
                })
                .catch(error => { callError('error', error.message, 'Error'); });
        }

    }, [jobID]);


    // reel list
    useEffect(() => {
        if (jobID > 0) {
            const paraPalletList = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_mode: 1,
                p_pallet_number: '',
                p_child_reel_number: 0,
                p_id_sheeter_hdr: jobID
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_DETAILS, 'POST', { 'Content-Type': 'application/json' }, paraPalletList)
                .then(pallets => {
                    if (pallets && pallets.length > 0) {
                        // setPalletList(pallets);
                        const formattedPallets = pallets.map((item) => ({
                            ...item,
                            shift_date: dayjs(item.shift_date).format('DD-MM-YYYY'), // Format the date
                        }));

                        // Set the formatted array to the state
                        setPalletList(formattedPallets);

                        const totalNumberOfSheets = pallets.reduce((total, pallet) => total + pallet.no_of_sheets, 0);
                        setActualNoOfSheetsProduced(totalNumberOfSheets);

                        calculatePallets_WithMoreParameter(sheeterNoOfSheets, totalNumberOfSheets);
                        setviewSheeterQRcode(true);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [jobID]);

    const loadPalletList = () => {

        if (jobID > 0) {
            const paraPalletList = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_mode: 1,
                p_pallet_number: '',
                p_child_reel_number: 0,
                p_id_sheeter_hdr: jobID
            };

            callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_PALLET_DETAILS, 'POST', { 'Content-Type': 'application/json' }, paraPalletList)
                .then(pallets => {
                    if (pallets && pallets.length > 0) {
                        // setPalletList(pallets);
                        const formattedPallets = pallets.map((item) => ({
                            ...item,
                            shift_date: dayjs(item.shift_date).format('DD-MM-YYYY'), // Format the date
                        }));

                        // Set the formatted array to the state
                        setPalletList(formattedPallets);

                        const totalNumberOfSheets = pallets.reduce((total, pallet) => total + pallet.no_of_sheets, 0);
                        setActualNoOfSheetsProduced(totalNumberOfSheets);

                        calculatePallets_WithMoreParameter(sheeterNoOfSheets, totalNumberOfSheets);
                        setviewSheeterQRcode(true);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }


    useEffect(() => {
        if (shiftCodeUpdate) return;

        const params = { p_companyid: localStorage.getItem('companyid') };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setShiftCodes(data);
                    const selectedShift = data.find(shift => shift.shiftid === updateshiftCode);
                    if (selectedShift) {
                        setWinderShiftCode(selectedShift);
                        setWinderShiftID(selectedShift.shiftid);
                    }
                }
                setShiftCodeUpdate(true);
            })
            .catch(error => alert(error.message));
    }, [updateshiftCode, shiftCodeUpdate]);

    useEffect(() => {
        if (operatorUpdate) return;

        const params = { p_companyid: localStorage.getItem('companyid'), p_plantid: 1 };

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setOperator(data);
                    const selectedOperator = data.find(operator => operator.operator_code === updateOperator);
                    if (selectedOperator) {
                        setSelectedOperator(selectedOperator);
                        setSelectedOperatorName(selectedOperator.operator_code);
                        setWinderOperators(selectedOperator.operator_code);
                    }
                }
                setOperatorUpdate(true);
            })
            .catch(error => alert(error.message));
    }, [updateOperator, operatorUpdate]);


    useEffect(() => {
        if (cutterCodeUpdate) return;

        const para = {
            p_companyid: 58,
        }

        callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_CUTTER_CODE, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data?.length) {
                    setCutterCodes(data);

                    const selectedOperator = data.find(operator => operator.id === updateCutterCode);
                    if (selectedOperator) {
                        setSelectedCutterCodes(selectedOperator);

                    }

                }
                setCutterCodeUpdate(true);
            })
            .catch(error => {
                alert(error.message);
            });


    }, [updateCutterCode, cutterCodeUpdate]);


    const RefreshSelectedChilddata = (selectedReels) => {
        setSelectedChip('View Sheeter Process');

        // const selectedReels = reelList.filter((reels) => selectedRows.includes(reels.id_reel));

        if (selectedReels.length > 0) {
            // Extract reference values from the first item in the selectedReels
            const { master_reel: firstMasterReel, d_width: firstWidth, d_length: firstLength } = selectedReels[0];

            // Check if all selected reels have the same values for master_reel, d_width, and d_length
            const allSame = selectedReels.every((reel) =>
                reel.master_reel === firstMasterReel &&
                reel.d_width === firstWidth &&
                reel.d_length === firstLength
            );

            if (!allSame) {
                // Notify user if values are different
                // alert("Selected reels have different 'master_reel', 'd_width', or 'd_length' values.");

                callError('info', 'Selected reels have different Master Reel, Width, or Length values.', 'Warning');
                return; // Stop further execution if values are different
            }
            else {
                setviewSheeterchildRollDetail(true);
                setViewReelList(false);
                let totalsheets = 0;
                let totalQuantity = 0;
                let s_length = 0;
                let s_width = 0;
                let s_gsm = 0;

                // find each reel wise number of sheets
                selectedReels.forEach((reel) => {
                    // Access the length property of each reel
                    let reelLength = reel.reel_length;
                    let d_length = reel.d_length / 100;
                    let number_of_sheets = parseInt(reelLength / d_length);
                    let cuts = parseInt(reel.master_reel / reel.d_width);

                    s_length = reel.d_length;
                    s_width = reel.d_width;
                    s_gsm = reel.gsm;

                    number_of_sheets = number_of_sheets * cuts;
                    totalsheets = totalsheets + number_of_sheets;
                    totalQuantity = totalQuantity + reel.quantity;

                    console.log(reelLength);
                });


                setTotalReelSheets(totalsheets);

                setSheeterWidth(s_width);
                setSheeterLength(s_length);
                setSheeterGSM(s_gsm);
                setSheeterQuantity(totalQuantity);

            }
        }

        // If all values are the same, update the selectedReelList
        setSelectedReelList(selectedReels);
    }



    const handleCallEdit = (indent, line) => {

        setSelectedChip('View Reel List');
        setindentNo(indent);
        setlineNo(line);

        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_indent_no: indent,
            p_line_no: line,
            p_release_no: selectedMO,

        };
        callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_CHILD_REEL_LIST, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    setReelList(data);
                    setViewReelList(true);
                    getloosePalletDetails(indent, line);
                } else {
                    // No data found
                    setReelList([]);
                    setViewReelList(false);
                    callError('info', 'No data found, Kindly adjust data range.', 'info');
                }
            })
            .catch(error => { callError('error', error.message, 'Error'); });

    };

    const getloosePalletDetails = (indent, line) => {
        const orderData = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_indent_no: indent,
            p_line_no: line,
            p_release_no: selectedMO,

        };
        callApi(API_ENDPOINTS.PROD_MANAGEMENT__GET_ORDER_LINE_ITEMS_WISE_PALLET_LIST_LOOSE_PALLET, 'POST', { 'Content-Type': 'application/json' }, orderData)
            .then(data => {
                if (data && data.length > 0) {
                    setloosepalletDet(data);

                } else {
                    // No data found
                    setloosepalletDet([]);

                }
            })
            .catch(error => { callError('error', error.message, 'Error'); });
    }

    const filteredReelData = reelList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const filteredPalletData = palletList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });



    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = reelList.map((row) => row.id_reel);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;


    // pallet list
    const handleSelectAllClickPallet = (event) => {
        if (event.target.checked) {
            const newSelectedRows = palletList.map((row) => row.pallet_id);
            setSelectedPalletRows(newSelectedRows);
            return;
        }
        setSelectedPalletRows([]);
    };

    const handleRowCheckboxClickPallet = (event, rowId) => {
        const selectedIndex = selectedPalletRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedPalletRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedPalletRows.slice(1);
        } else if (selectedIndex === selectedPalletRows.length - 1) {
            newSelectedRows = selectedPalletRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedPalletRows.slice(0, selectedIndex),
                ...selectedPalletRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedPalletRows(newSelectedRows);

    };

    const isSelectedPallet = (rowId) => selectedPalletRows.indexOf(rowId) !== -1;



    const LoadSelectedLineItemList = () => {

        setSelectedChip('View Sheeter Process');

        const selectedReels = reelList.filter((reels) => selectedRows.includes(reels.id_reel));

        if (selectedReels.length > 0) {
            // Extract reference values from the first item in the selectedReels
            const { master_reel: firstMasterReel, d_width: firstWidth, d_length: firstLength } = selectedReels[0];

            // Check if all selected reels have the same values for master_reel, d_width, and d_length
            const allSame = selectedReels.every((reel) =>
                reel.master_reel === firstMasterReel &&
                reel.d_width === firstWidth &&
                reel.d_length === firstLength
            );

            if (!allSame) {
                // Notify user if values are different
                // alert("Selected reels have different 'master_reel', 'd_width', or 'd_length' values.");

                callError('info', 'Selected reels have different Master Reel, Width, or Length values.', 'Warning');
                return; // Stop further execution if values are different
            }
            else {
                setviewSheeterchildRollDetail(true);
                setViewReelList(false);
                let totalsheets = 0;
                let totalQuantity = 0;
                let s_length = 0;
                let s_width = 0;
                let s_gsm = 0;

                // find each reel wise number of sheets
                selectedReels.forEach((reel) => {
                    // Access the length property of each reel
                    let reelLength = reel.reel_length;
                    let d_length = reel.d_length / 100;
                    let number_of_sheets = parseInt(reelLength / d_length);
                    let cuts = parseInt(reel.master_reel / reel.d_width);

                    s_length = reel.d_length;
                    s_width = reel.d_width;
                    s_gsm = reel.gsm;

                    number_of_sheets = number_of_sheets * cuts;
                    totalsheets = totalsheets + number_of_sheets;
                    totalQuantity = totalQuantity + reel.quantity;

                    console.log(reelLength);
                });


                setTotalReelSheets(totalsheets);

                setSheeterWidth(s_width);
                setSheeterLength(s_length);
                setSheeterGSM(s_gsm);
                setSheeterQuantity(totalQuantity);
                setActualNoOfSheetsProduced(0);
                setSheetCounts([]);

                setSheeterTotalLPallet(0);
                setSheeterPalletWeight(0); // round up only two decimal
                setSheeterTotalPallet(0);
                setSheeterBalanceWeight(0);// round up only two decimal
                setChecked(false);
                setDisabledLooseBundleOption(false);
                setdisableReelWiseSheetInput(false);
            }
        }

        // If all values are the same, update the selectedReelList
        setSelectedReelList(selectedReels);

        console.log(selectedReels);
    };


    const [isDataLoadeds, setIsDataLoadeds] = useState(false);

    useEffect(() => {
        if (!isDataLoadeds) {

            LoadOrderList();

        }
    }, [isDataLoadeds]);


    const LoadOrderList = () => {
        const p_frommodate = dayjs(FromShiftDate).format('YYYY-MMM-DD');
        const p_tomodate = dayjs(ToShiftDate).format('YYYY-MMM-DD');
        const para = {
            p_companyid: localStorage.getItem('companyid'),

            p_frommodate,
            p_tomodate
        };

        callApi(API_ENDPOINTS.SHEETER_CONVERTION_PROCESS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setSummaryList(data);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    }

    useEffect(() => {
        const fetchData = async () => {
            const p_companyid = localStorage.getItem('companyid');
            const p_frommodate = dayjs(FromShiftDate).format('YYYY-MMM-DD');
            const p_tomodate = dayjs(ToShiftDate).format('YYYY-MMM-DD');

            const para = {
                p_companyid: p_companyid,
                page: currentPage,
                pageSize: pageSize,
                p_frommodate,
                p_tomodate
            };
            setLoading(true);
            try {
                const data = await callApi(API_ENDPOINTS.SHEETER_CONVERTION_PROCESS_LIST, 'POST', { 'Content-Type': 'application/json' }, para);
                if (data) setSummaryList(data);
            } catch (error) {
                alert(error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [currentPage, pageSize, FromShiftDate, ToShiftDate, setFromDate, setToDate]);


    const [expandedRow, setExpandedRow] = useState(null);  // Track which row is expanded
    const [expandedData, setExpandedData] = useState({});

    const handleExpandRow = async (row) => {
        const { indent_no } = row;
        // Toggle expansion
        if (expandedRow === indent_no) {
            setExpandedRow(null);
            return;
        }


        try {

            const p_frommodate = dayjs(FromDate).format('YYYY-MM-DD hh:mm:ss');
            const p_tomodate = dayjs(ToDate).format('YYYY-MM-DD hh:mm:ss');

            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_indent_no: row.indent_no,
                p_frommodate,
                p_tomodate
            };

            callApi(API_ENDPOINTS.SHEETER_GetChildrollSheetsProductionBasedOnCONumberAPI, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setExpandedData((prev) => ({ ...prev, [indent_no]: data }));
                        setExpandedRow(indent_no);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        } catch (error) {
            console.error("Failed to fetch expanded row data", error);
        }

    };


    const [viewJob, setViewJob] = useState(true);
    const [newJob, setNewJob] = useState(false);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('Sheeter Convertion List');
    const openFirst = Boolean(anchorElFirst);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Child Roll List') {
            setSelectedStatus('All');
        }
        else if (option === 'Unweighted Reels') {
            setSelectedStatus('Booked');
        }
        else if (option === 'FG Child Roll') {
            setSelectedStatus('fg');
        }
        else if (option === 'Inprogress Child Roll') {
            setSelectedStatus('wip');
        }
        else if (option === 'Cancelled Child Roll') {
            setSelectedStatus('cancelled');
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const handleShowNewVendor = () => {
        setJobID(0);
        setViewJob(false);
        setviewSheeterQRcode(false);
        setNewJob(true);
        setViewReelList(false);
        setviewSheeterchildRollDetail(false);
    }

    const convertInputDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${month}/${day}/${year}`;
    };

    const convertDataDate = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${month}/${day}/${year}`;
    };

    const summaryData = summaryList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied

                if (key === 'from_date' || key === 'to_date') {
                    // Convert row date to Date object
                    const rowDate = new Date(convertDataDate(row.date));
                    const fromDate = filters.from_date ? new Date(convertInputDate(filters.from_date)) : null;
                    const toDate = filters.to_date ? new Date(convertInputDate(filters.to_date)) : null;

                    // Check if row date is within the range
                    if (fromDate && toDate) {
                        return rowDate >= fromDate && rowDate <= toDate;
                    } else if (fromDate) {
                        return rowDate >= fromDate;
                    } else if (toDate) {
                        return rowDate <= toDate;
                    }
                    return true;
                }

                // Default string comparison for other filters
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });



    // sorting process
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortColumn, setSortColumn] = useState('date'); // Default sort by 'date'


    const handleSort = (column) => {
        const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newDirection);
        setSortColumn(column);
    };

    const sortedData = useMemo(() => {
        return [...summaryData].sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortDirection === 'asc' ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
    }, [summaryData, sortColumn, sortDirection]);




    const [selectedChip, setSelectedChip] = useState('Combinations');





    const handleSubMenuButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        if (buttonName === 'View Reel List') {
            if (!disableProceedBtn) {
                setviewSheeterchildRollDetail(false);
                setViewReelList(true);
                setviewSheeterQRcode(false); //newly added
            }
            else {
                setShiftDate(dayjs());

                const orderData = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_plantid: 1,
                    p_indent_no: indentNo,
                    p_line_no: lineNo,
                    p_release_no: selectedMO,

                };
                callApi(API_ENDPOINTS.SHEETER_CONVERTION_GET_ORDER_LINE_ITEMS_WISE_CHILD_REEL_LIST, 'POST', { 'Content-Type': 'application/json' }, orderData)
                    .then(data => {
                        if (data && data.length > 0) {
                            setReelList(data);
                            setViewReelList(true);
                            getloosePalletDetails(indentNo, lineNo);
                            setviewSheeterchildRollDetail(false);
                            setviewSheeterQRcode(false);
                            setDisableProceedBtn(false);
                        } else {
                            // No data found
                            setviewSheeterchildRollDetail(false);
                            setReelList([]);
                            setViewReelList(false);
                            setviewSheeterQRcode(false);
                            setDisableProceedBtn(false);
                            callError('info', 'No data found, Kindly adjust data range.', 'info');
                        }
                    })
                    .catch(error => { callError('error', error.message, 'Error'); });

            }
        }
        else if (buttonName === 'View Sheeter Process') {
            setviewSheeterchildRollDetail(true);
            setViewReelList(false);
        }
        else if (buttonName === 'Line Item Wise Achieved Reels') {
            // setviewSheeterchildRollDetail(true);
            setViewReelList(false);
        }
        else if (buttonName === 'View Summary') {
            // setviewSheeterchildRollDetail(true);
            setViewJob(true);
            setNewJob(false);
            setJobID(0);
        }
    };



    const [sheetCounts, setSheetCounts] = useState([]);

    // const handleInputChange = (id_reel, value) => {
    //     setSheetCounts((prev) => {
    //         const updatedCounts = prev.filter((item) => item.id_reel !== id_reel);
    //         return [...updatedCounts, { id_reel, sheetCount: value }];
    //     });


    // };

    const handleInputChange = (id_reel, value) => {
        const numericValue = parseInt(value, 10) || 0;

        setSheetCounts((prev) => {
            // If `sheetCounts` is empty, add the new value directly
            if (prev.length === 0) {
                setActualNoOfSheetsProduced(numericValue);
                return [{ id_reel, sheetCount: numericValue }];
            }

            // Calculate the total from the existing values
            const totalSheets = prev.reduce(
                (total, item) => total + (parseInt(item.sheetCount, 10) || 0),
                0
            );

            // Update or add the new entry
            const updatedCounts = prev.filter((item) => item.id_reel !== id_reel);
            updatedCounts.push({ id_reel, sheetCount: numericValue });

            // Update the total with the new value
            const newTotal =
                totalSheets +
                numericValue -
                (prev.find((item) => item.id_reel === id_reel)?.sheetCount || 0);
            setActualNoOfSheetsProduced(newTotal);

            // calculatePallets_WithMoreParameter(sheeterNoOfSheets, newTotal);
            UseLoosePalleteForCurrentProcess(sheeterNoOfSheets, checked, newTotal, updatedCounts);
            return updatedCounts;
        });
    };



    const [checked, setChecked] = useState(false);
    const [disabledLooseBundleOption, setDisabledLooseBundleOption] = useState(false);


    function allocateSheets(pallet, sheetCounts) {
        const MAX_SHEETS = sheeterNoOfSheets;
        let remainingSheets = MAX_SHEETS - pallet[0].number_of_sheets;
        const sheetsAllocated = []; // To track how sheets are allocated from each reel

        for (let i = 0; i < sheetCounts.length && remainingSheets > 0; i++) {
            const currentReel = sheetCounts[i];
            const sheetsToTake = Math.min(currentReel.sheetCount, remainingSheets);

            // Deduct sheets from reel and remaining sheets
            currentReel.sheetCount -= sheetsToTake;
            remainingSheets -= sheetsToTake;

            // Record the allocation
            sheetsAllocated.push({
                id_reel: currentReel.id_reel,
                allocatedSheets: sheetsToTake,
            });
        }

        // Update the pallet
        pallet[0].number_of_sheets = MAX_SHEETS - remainingSheets;
        let palletwt = ((sheeterLength / 100) * (sheeterWidth / 100) * (sheeterGSM / 1000) * (MAX_SHEETS - remainingSheets));

        // Round palletwt to two decimal places
        palletwt = parseFloat(palletwt.toFixed(2));
        pallet[0].pallet_weight = palletwt;

        return {
            pallet,
            sheetsAllocated,
            updatedSheetCounts: sheetCounts,
        };
    }

    const [loosepalletDetTemp, setloosepalletDetTemp] = useState([]);
    const [sheetCountsTemp, setSheetCountsTemp] = useState([]);
    const [allupdatedSheetDet, setAllupdatedSheetDet] = useState([]);

    const handleUseLoosePallete = (event) => {
        setChecked(event.target.checked);
        if (event.target.checked && loosepalletDet.length > 0) {
            // Automatically select the first row when checked
            setSelectedPallet([loosepalletDet[0]]);
        }
        // else {
        //     setSelectedPallet([]);
        // }



        UseLoosePalleteForCurrentProcess(sheeterNoOfSheets, event.target.checked, actualNoOfSheetsProduced, sheetCounts);
    };


    const UseLoosePalleteForCurrentProcess = (sheeterNoOfSheets, checked, actualNoOfSheetsProduced, sheetCounts) => {
        let loosepalletDetTemp = structuredClone(selectedPallet);
        let sheetCountsTemp = structuredClone(sheetCounts);

        if (checked) {
            if (selectedPallet.length > 0) {
                if (sheetCounts.length > 0) {
                    const result = allocateSheets(loosepalletDetTemp, sheetCountsTemp);

                    const totalSheetCount = sheetCountsTemp.reduce((total, reel) => total + reel.sheetCount, 0);

                    calculatePallets_WithMoreParameter(sheeterNoOfSheets, totalSheetCount);

                    setAllupdatedSheetDet(result);
                    setloosepalletDetTemp(loosepalletDetTemp);
                    setSheetCountsTemp(sheetCountsTemp);
                    setActualNoOfSheetsProduced(totalSheetCount);
                }
                else {
                    setAllupdatedSheetDet([]);
                    setloosepalletDetTemp([]);
                    setSheetCountsTemp([]);
                    setActualNoOfSheetsProduced(0);
                }
            }
        }
        else {
            let totalSheetCount = 0
            if (sheetCounts.length > 0) {
                totalSheetCount = sheetCounts.reduce((total, reel) => total + reel.sheetCount, 0);
            }
            else {
                totalSheetCount = actualNoOfSheetsProduced;
            }

            calculatePallets_WithMoreParameter(sheeterNoOfSheets, totalSheetCount);
            setActualNoOfSheetsProduced(totalSheetCount);
            setAllupdatedSheetDet([]);
            setloosepalletDetTemp([]);
            setSheetCountsTemp([]);
        }
    }

    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogReamBundle, setOpenDialogReamBundle] = useState(false);

    // Handlers to open and close the dialog
    const handleDialogOpen = () => setOpenDialog(true);
    const handleDialogClose = () => setOpenDialog(false);

    // Handlers to open and close the dialog
    const handleDialogOpenReamBundle = () => setOpenDialogReamBundle(true);
    const handleDialogCloseReamBundle = () => setOpenDialogReamBundle(false);

    // Calculate the number of pages
    const pageCount = Math.ceil(summaryList.length / recordsPerPage);

    // Get the records for the current page
    const currentRecords = sortedData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const [selectedPallet, setSelectedPallet] = useState([]);

    const handleSelect = (id_pallet) => {
        setSelectedPallet([id_pallet]);

    };

    // Use `useEffect` to trigger `UseLoosePalleteForCurrentProcess` after `selectedPallet` updates
    useEffect(() => {
        if (selectedPallet.length > 0) {
            UseLoosePalleteForCurrentProcess(
                sheeterNoOfSheets,
                checked, // Assume checked is true for selection
                actualNoOfSheetsProduced,
                sheetCounts
            );
        }
    }, [selectedPallet, setSelectedPallet]); // Runs whenever `selectedPallet` updates


    const handleIndentNoChange = (event, value) => {
        if (value !== undefined && value != null) {
            setFilterIndentno(value);
            LoadOrderLineItemDetailsFIlterByCONumber(value.indent_no)
        }
        else {
            setFilterIndentno('');
            LoadOrderLineItemDetailsWithOutFilter();
        }
    }

    const fetchIndentNo = async () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 0,
        }

        try {
            const data = await callApi(API_ENDPOINTS.REPORT_GetProductionDistinctOrderNoForConversionReport, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data?.length > 0) {
                setIndentNoList(data);
            }
        }
        catch (error) {
            alert(error);
        }
    }


    useEffect(() => {
        fetchIndentNo();
    }, [])

    // filter oprations 
    const columns = ['job_number', 'shift_code', 'shift_date', 's_operator', 'cr_number', 'indent_no', 'pallet_count'];
    const autoCompleteColumns = ['job_number', 'shift_code', 'shift_date', 's_operator', 'cr_number', 'indent_no', 'pallet_count'];

    const handleFilterChangeTable = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const uniqueValues = {
        job_number: [...new Set(summaryList.map(row => row.job_number))],
        shift_code: [...new Set(summaryList.map(row => row.shift_code))],
        shift_date: [...new Set(summaryList.map(row => row.shift_date))],
        s_operator: [...new Set(summaryList.map(row => row.s_operator))],
        cr_number: [...new Set(summaryList.map(row => row.cr_number))],
        indent_no: [...new Set(summaryList.map(row => row.indent_no))],
        pallet_count: [...new Set(summaryList.map(row => row.pallet_count))],
        // status: [...new Set(summaryList.map(row => row.status))],


    };
    const DeleteSelectedPalletsProductionJobDetails = () => {
        if (!hasPermission(userPermissions, "Cutter Sheeter Convertion", "Delete")) {
            alert("Access denied. You don’t have permission to delete the pallets.");
            return; // Exit the function if permission is not granted
        }

        let printselectedPalletDetails = palletList;
        printselectedPalletDetails = palletList.filter((pallet) => selectedPalletRows.includes(pallet.pallet_id));

        if (jobID === 0) {

            callError('warning', 'Please select the Job Details to delete', 'Warning');
            return;
        }

        if (printselectedPalletDetails.length === 0) {

            callError('warning', 'Please select  at least one pallet code to delete', 'Warning');
            return;
        }

        if (palletList.length === printselectedPalletDetails.length) {
            callError('warning', 'Cannot delete all pallets in a Job. Please delete the entire job.', 'Warning');
            return;
        }

        const confirmDelete = window.confirm(`Are you sure you want to delete the selected pallets in job details?`);

        if (confirmDelete) {
            setSheeterMsgOpen(false);

            const parameter = {
                p_company_id: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_selected_pallets: printselectedPalletDetails,
                p_user: localStorage.getItem('userID'),
            };

            // create pallets
            callApi(API_ENDPOINTS.SHEETER_DELETE_SELECTED_PALLET_PRODUCTION_JOB_DETAILS, 'POST', { 'Content-Type': 'application/json' }, parameter)
                .then(data => {
                    if (data && data.length > 0) {
                        if (data === 'Selected pallets deleted successfully.') {
                            LoadOrderList();

                            callError('success', data, 'Success');
                            loadPalletList();

                        }
                        else {
                            callError('warning', data, 'Warning');
                        }
                    }
                    else {
                        callError('error', 'Unable to delete the Selected Pallets In Job.', 'Error');
                    }
                })
                .catch(error => {
                    callError('error', error.message, 'Error');
                });
        }


    }

    const handleRowClick = (event, id, status) => {
        if (status === 'converted') return;
        handleRowCheckboxClick(event, id);
    };


    return (
        <Box>
            {viewJob && (
                <>


                    <Dialog
                        open={openWIPListModal}
                        onClose={handleCloseWIPListModal}
                        fullWidth
                        maxWidth="xl"
                    >

                        <DialogContent>
                            {/* Correctly pass the prop inside the component tag */}
                            <ReportSheeterProductionWIPPalletList
                                handleBackSheeterMachineEntry={handleBackSheeterMachineEntry}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseWIPListModal} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Divider />

                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                            {/* First Menu */}
                            <Button
                                color="secondary"
                                onClick={handleMenuClickFirst}
                                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                {selectedOptionFirst}
                            </Button>
                            <Menu
                                anchorEl={anchorElFirst}
                                open={openFirst}
                                onClose={handleMenuCloseFirst}

                            >
                                <MenuItem onClick={() => handleMenuItemClickFirst('All Child Roll List')}>Sheeter Convertion List</MenuItem>
                            </Menu>

                            {/* Adding margin-left: auto to push the button to the right */}


                            <Box sx={{ marginLeft: 'auto', }}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleOpenWIPListModal}
                                    sx={{ marginRight: 1 }}
                                >
                                    View WIP Pallet List
                                </Button>
                                {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Create") && (
                                    <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />}>New</Button>

                                )}
                            </Box>
                            {/* Second Menu */}
                            {/* test */}
                            <IconButton
                                size="small"
                                // edge="start"
                                // color="inherit"
                                aria-label="menu"
                                sx={{ ml: 2 }}
                                onClick={handleMenuClickSecond}
                            >
                                <MoreVertIcon sx={{ fontSize: "18px" }} />
                            </IconButton>
                            <Menu
                                anchorEl={anchorElSecond}
                                open={openSecond}
                                onClose={handleMenuCloseSecond}
                            >
                                <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Import Child rolls" />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Child rolls" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                    <ListItemIcon>
                                        <ViewColumnIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Current View" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Preference " />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                    <ListItemIcon>
                                        <RefreshIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                    <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                        Reset Columns Width
                                    </Button>
                                </MenuItem>
                            </Menu>



                            <div>
                                <IconButton onClick={handleBackWinderMachineEntry} >
                                    <Close sx={{ fontSize: "18px", color: "#2196F3" }} />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>

                    <Grid container padding="5px 0px 5px 5px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >



                        <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px">
                            <FormControl fullWidth size="small">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        style={{ marginLeft: '10px' }}
                                        id="FromDate"
                                        value={dayjs(FromShiftDate)}
                                        onChange={(date) => handleFromShiftDateChange(date)}

                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard', // Removes the filled/outlined border
                                                InputProps: {
                                                    disableUnderline: true, // Remove underline from 'standard' variant
                                                },
                                                sx: {
                                                    backgroundColor: 'transparent',
                                                    padding: 0,
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '18px', // 👈 smaller icon size
                                                    },
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: '6px', // optional: reduce padding around icon
                                                    },
                                                },
                                            }
                                        }}
                                        renderInput={(props) => <TextField {...props} />}
                                        autoFocus
                                        format="DD-MMM-YYYY"
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item mt="5px" ml="10px" mr="10px">
                            <Typography fontWeight="bold">-</Typography>
                        </Grid>


                        <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px" mr="10px">
                            <FormControl fullWidth size="small" >
                                <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                    <DatePicker
                                        id="ToDate"
                                        value={dayjs(ToShiftDate)}
                                        format="DD-MMM-YYYY"
                                        onChange={(date) => handleToShiftDateChange(date)}

                                        slotProps={{
                                            textField: {
                                                size: 'small',
                                                variant: 'standard', // Removes the filled/outlined border
                                                InputProps: {
                                                    disableUnderline: true, // Remove underline from 'standard' variant
                                                },
                                                sx: {
                                                    backgroundColor: 'transparent',
                                                    padding: 0,
                                                    '& .MuiInputBase-root': {
                                                        border: 'none',
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: '18px', // 👈 smaller icon size
                                                    },
                                                    '& .MuiInputBase-root': {
                                                        paddingRight: '6px', // optional: reduce padding around icon
                                                    },
                                                },
                                            }
                                        }}
                                        renderInput={(props) => <TextField {...props} />}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>


                    </Grid>

                    <Divider sx={{ marginTop: "5px" }} />

                    <ResponsiveBox customMaxHeight={{
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '74vh', // Medium devices (small laptops)
                        lg: '82vh', // Large devices (desktops)
                        xl: '86vh', // Extra large devices (large desktops)
                    }}>
                        <CustomTableContainer colors={colors}>
                            <TableContainer >
                                {loading ? (
                                    <SkeletonTableLoader rows={5} columns={11} />
                                ) : (
                                    //  sx={{ height: 10 }}
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                            <TableRow>
                                                <TableCell onClick={() => handleSort('job_number')}>
                                                    JOB NUMBER {sortColumn === 'job_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('shift_code')}>
                                                    SHIFT CODE {sortColumn === 'shift_code' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('shift_date')}>
                                                    SHIFT DATE {sortColumn === 'shift_date' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('s_operator')}>
                                                    OPERATOR {sortColumn === 's_operator' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>
                                                <TableCell onClick={() => handleSort('cr_number')} sx={{ width: '250px' }}>
                                                    CHILD ROLL NUMBER {sortColumn === 'cr_number' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell onClick={() => handleSort('indent_no')}>
                                                    CO NUMBER {sortColumn === 'indent_no' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                <TableCell onClick={() => handleSort('pallet_count')}>
                                                    TOTAL PALLETS {sortColumn === 'pallet_count' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell>

                                                {/* <TableCell onClick={() => handleSort('status')}>
                                                    STATUS {sortColumn === 'status' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                                </TableCell> */}

                                                {/* <TableCell>
                                                    <IconButton onClick={handleOpen}>
                                                        <Searchicon style={{ fontSize: "16px" }} />
                                                    </IconButton>
                                                    <Modal
                                                        open={open}
                                                        onClose={handleClose}
                                                        aria-labelledby="modal-modal-title"
                                                        aria-describedby="modal-modal-description"
                                                    >
                                                        <Box sx={{ position: 'absolute', top: '38.2%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: colors.primary[400], boxShadow: 29, p: 4, minWidth: 300 }}>

                                                          

                                                            <TextField
                                                                label="Child Roll Number"
                                                                name="cr_number"
                                                                size='small'
                                                                value={filters.cr_number}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <TextField
                                                                label="CO Number"
                                                                name="indent_no"
                                                                size='small'
                                                                value={filters.indent_no}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />
                                                           
                                                            <Button variant="contained" color="secondary" onClick={() => { handleClose(); }} style={{ marginTop: 10 }}>
                                                                Apply Filter
                                                            </Button>
                                                        </Box>
                                                    </Modal>
                                                </TableCell> */}
                                            </TableRow>
                                            <TableFilterRow
                                                columns={columns}
                                                filters={filters}
                                                handleFilterChange={handleFilterChangeTable}
                                                uniqueValues={uniqueValues}
                                                autoCompleteColumns={autoCompleteColumns}
                                            />
                                        </TableHead>
                                        <TableBody>
                                            {currentRecords.map((row, index) => (
                                                <TableRow key={row.id} sx={{ backgroundColor: index % 2 === 0 ? theme.palette.background.default : alpha(theme.palette.action.hover, 0.04), }}>
                                                    <TableCell> <span
                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                        onClick={() => handlecallEditJob(row.job_number)}
                                                    >
                                                        JOB# {row.job_number}
                                                    </span></TableCell>
                                                    <TableCell sx={{ width: '100px' }}>{row.shift_code}</TableCell>
                                                    <TableCell>{row.shift_date}</TableCell>
                                                    <TableCell>{row.s_operator}</TableCell>
                                                    <TableCell >
                                                        {/* <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                    onClick={() => handlecallEditJob(row.id, row.cr_number)}
                                                > */}
                                                        {row.cr_number}
                                                        {/* </span> */}
                                                    </TableCell>
                                                    <TableCell>{row.indent_no}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right', minWidth: '10px' }}>{`${row.pallet_count} `}</TableCell>
                                                    {/* <TableCell>{row.status}</TableCell> */}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}
                                <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                                    <Pagination
                                        count={pageCount}
                                        page={currentPage}
                                        onChange={(event, value) => setCurrentPage(value)}

                                    />
                                </Box>
                            </TableContainer>
                        </CustomTableContainer>
                    </ResponsiveBox>


                </>
            )}

            {newJob && (
                <>

                    <Header title={t('prod_menu.cuttersheeterconvertion')} subtitle="" callback={callbacknewSheeterProcess} />

                    <Dialog
                        open={open}
                        onClose={closepopup}
                        fullWidth
                        maxWidth="xs"
                    >
                        <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
                            <QualityCheckRejectProcee rejectReelType={'PALLET'} rejectReason={rejectReason} setRejectReason={setRejectReason} selectedReason={selectedReason} setSelectedReason={setSelectedReason} rejectProductType={rejectProductType} setRejectProductType={setRejectProductType} rejectStatus={rejectStatus} setRejectStatus={setRejectStatus} rejectReasonID={rejectReasonID} setRejectReasonID={setRejectReasonID} rejectRemarks={rejectRemarks} setRejectRemarks={setRejectRemarks} enableReject={enableReject} setEnableReject={setEnableReject} />
                        </DialogContent>
                        <DialogActions sx={{ backgroundColor: theme.palette.background.default }}>
                            <Button onClick={closepopup} variant="contained">
                                Update
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Divider />
                    <Grid container display="flex-start" padding={0.5}>
                        {viewReelList && (
                            <>
                                <Grid item md={0} ml="1px" mr="1px">
                                    <Tooltip title="Back to Line item wise achieved reel ">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleSubMenuButtonClick('Line Item Wise Achieved Reels')}  >
                                                <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'Line Item Wise Achieved Reels' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Line Item Wise Achieved Reels</Typography>
                                            </IconButton>
                                            {/* <span style={{ fontSize: 12 }}>Edit</span> */}
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                <Grid item md={0} ml="1px" mr="1px">
                                    <Tooltip title="View available reel list for production">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleSubMenuButtonClick('View Reel List')} >
                                                <CheckCircleOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'View Reel List' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Reel List</Typography>
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </Grid>
                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                            </>
                        )}


                        {viewSheeterchildRollDetail && (
                            <>
                                {jobID === 0 && (
                                    <>
                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Back to View reel list">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Reel List')} >
                                                        <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'View Reel List' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Reel List</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Convert pallets to reams process">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Sheeter Process')} >
                                                        <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'View Sheeter Process' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Sheeter Process</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

                                    </>
                                )}
                                {jobID > 0 && (
                                    <>

                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Back to Summary list">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Summary')} >
                                                        <ArrowBackIcon style={{ fontSize: "18px", color: selectedButton === 'View Summary' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Summary</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


                                        <Grid item md={0} ml="1px" mr="1px">
                                            <Tooltip title="Convert pallets to reams process">
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <IconButton onClick={() => handleSubMenuButtonClick('View Sheeter Process')} >
                                                        <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'View Sheeter Process' ? "yellow" : "#009688" }} />
                                                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Sheeter Process</Typography>
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                        <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                                    </>
                                )}
                            </>
                        )}
                    </Grid>

                    {(viewSheeterchildRollDetail || viewReelList) && <Divider />}

                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={sheeterMsgOpen} setParentRollMsgOpen={setSheeterMsgOpen} parentRollSeverityvalue={sheeterSeverityvalue}
                        setParentRollSeverityvalue={setSheeterSeverityvalue} parentRollAlertTitleValue={sheeterAlertTitleValue}
                        setParentRollAlertTitleValue={setSheeterAlertTitleValue} parentRollMessageValue={sheeterMessageValue} setParentRollMessageValue={setSheeterMessageValue} />


                    {/* Summary List */}
                    {viewSheeterchildRollDetail === false ? (<>
                        <Box
                            sx={{
                                padding: "1px",
                                borderRadius: "10px",
                                maxHeight: {
                                    xs: '72vh', // Extra small devices (phones)
                                    sm: '72vh', // Small devices (tablets)
                                    md: '74vh', // Medium devices (small laptops)
                                    lg: '80vh', // Large devices (desktops)
                                    xl: '82vh', // Extra large devices (large desktops)
                                },
                                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: colors.primary[400],
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: colors.blueAccent[600],
                                    borderRadius: '10px',
                                    '&:hover': {
                                        background: colors.blueAccent[800],
                                    },
                                },
                                '&::-webkit-scrollbar-corner': {
                                    background: colors.primary[700],
                                }
                            }}>
                            <Grid container>



                                {/* Dialog component */}
                                <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="lg" fullWidth>
                                    <DialogContent style={{ padding: 2, backgroundColor: theme.palette.background.default }}>

                                        <ReelPendingConversionReport handleBackWinderMachineEntry={handleDialogClose} />

                                    </DialogContent>
                                </Dialog>




                                <Dialog open={openDialogReamBundle} onClose={handleDialogCloseReamBundle} maxWidth="lg" fullWidth>
                                    <DialogContent style={{ padding: 2, backgroundColor: theme.palette.background.default }}>

                                        <ReamBundlePendingConversionReport handleBackWinderMachineEntry={handleDialogCloseReamBundle} />

                                    </DialogContent>
                                </Dialog>


                                {viewReelList === false ? (
                                    <>
                                        <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                                            <Grid container padding="1px 0px 5px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                <Grid item xs={12} sm={12} md={1.6} lg={1} xl={1} display="flex-start" justifyContent="center">
                                                    <Typography variant="h6">CO Number</Typography>
                                                </Grid>

                                                {/* <Grid item xs={12} sm={11} md={3.8} lg={1.8} xl={2}>
                                                    <FormControl fullWidth size="small">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                style={{ marginLeft: '10px' }}
                                                                id="FromDate"
                                                                value={dayjs(FromDate)}
                                                                onChange={(date) => handleDateChange2(date)}
                                                                slotProps={{ textField: { size: 'small', } }}
                                                                renderInput={(props) => <TextField {...props} />}
                                                                autoFocus
                                                                format="DD-MMM-YYYY" // Use the appropriate format string
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>

                                                <Grid item xs={12} sm={11} md={3.8} lg={1.8} xl={2}>
                                                    <FormControl fullWidth size="small" >
                                                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                                            <DatePicker
                                                                id="ToDate"
                                                                value={dayjs(ToDate)}
                                                                format="DD-MMM-YYYY"
                                                                onChange={(date) => handleDateChange1(date)}
                                                                slotProps={{ textField: { size: 'small', } }}
                                                                renderInput={(props) => <TextField {...props} />}
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid> */}

                                                <Grid item xs={12} sm={11} md={3.8} lg={1.8} xl={2}>
                                                    <Autocomplete
                                                        fullWidth
                                                        value={filterIndentno}
                                                        onChange={handleIndentNoChange}
                                                        size="small"
                                                        style={{ fontSize: '12px' }}
                                                        options={indentNoList}
                                                        getOptionLabel={(option) => (option?.indent_no ? `${option.indent_no}` : '')} // Safely handle undefined
                                                        renderInput={(params) =>
                                                            <TextField required

                                                                {...params} variant="outlined" />}
                                                    />
                                                </Grid>

                                                <Grid>
                                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleDialogOpen} >
                                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Reel and Ream/Bundle Pending Conversion Reports</Typography>
                                                    </IconButton>
                                                </Grid>

                                                {/* <Grid >
                                                    <IconButton style={{ borderRadius: '8px', }} onClick={handleDialogOpenReamBundle} >
                                                        <Report style={{ marginRight: '5px', color: '#1e88e5' }} />
                                                        <Typography variant="button" textTransform={'none'} fontSize={13}>Ream/Bundle Pending Conversion Report</Typography>
                                                    </IconButton>
                                                </Grid> */}

                                            </Grid>
                                        </Grid>

                                        <Grid container padding="10px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>


                                    </>
                                ) : (null)}


                                {viewReelList === true ? (
                                    <>
                                        <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={9} xl={10}>

                                                <CustomTableContainer colors={colors}>
                                                    <TableContainer >
                                                        <Table size="small" stickyHeader >
                                                            <TableHead sx={{ height: 10 }} >
                                                                <TableRow>
                                                                    <TableCell>
                                                                        <Checkbox sx={{
                                                                            '& .MuiSvgIcon-root': { fontSize: 22 }, // Adjust the size of the checkbox icon
                                                                            color: 'secondary' // Custom color
                                                                        }}
                                                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredReelData.length}
                                                                            checked={selectedRows.length === filteredReelData.length}
                                                                            onChange={handleSelectAllClick}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: "center" }}>CHILD ROLL NUMBER</TableCell>

                                                                    <TableCell sx={{ textAlign: "center" }}> CO NUMBER</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>MASTER REEL</TableCell>
                                                                    <TableCell sx={{ textAlign: "center" }}>SIZE</TableCell>

                                                                    <TableCell sx={{ textAlign: "center" }}>REEL WEIGHT</TableCell>
                                                                    {/* <TableCell sx={{ textAlign: "center" }}></TableCell> */}

                                                                    {/* <TableCell>
                                                                      
                                                                        <Modal
                                                                          
                                                                            aria-labelledby="modal-modal-title"
                                                                            aria-describedby="modal-modal-description"
                                                                        >
                                                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                                <TextField
                                                                                    label="Parent Roll Number"
                                                                                    name="name"
                                                                                  
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                />
                                                                                <TextField
                                                                                    label="MA Number"
                                                                                    name="companyName"
                                                                                  
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                />

                                                                                <TextField
                                                                                    label="Status"
                                                                                    name="status"
                                                                                   
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    margin="normal"
                                                                                />


                                                                                <Button variant="contained" style={{ marginTop: 10 }}>
                                                                                   
                                                                                    Apply Filter
                                                                                </Button>
                                                                            </Box>
                                                                        </Modal>
                                                                    </TableCell> */}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {filteredReelData.map((row) => (

                                                                    <TableRow key={row.id_reel}

                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            opacity: 1
                                                                        }}

                                                                        onClick={(event) => handleRowClick(event, row.id_reel, row.status)}>
                                                                        <TableCell>
                                                                            <Checkbox
                                                                                sx={{
                                                                                    '& .MuiSvgIcon-root': { fontSize: 22 }, // Adjust the size of the checkbox icon
                                                                                    color: 'secondary' // Custom color
                                                                                }}
                                                                                checked={isSelected(row.id_reel)}
                                                                                disabled={row.status === 'converted'}
                                                                                onChange={(event) => handleRowCheckboxClick(event, row.id_reel)}
                                                                            />
                                                                        </TableCell>

                                                                        <TableCell sx={{ textAlign: "left" }}>{row.code}</TableCell>
                                                                        <TableCell sx={{ textAlign: "left" }}>{row.indent_no}</TableCell>
                                                                        <TableCell sx={{ textAlign: "right" }}>{row.master_reel}</TableCell>

                                                                        <TableCell sx={{ textAlign: "center" }}>
                                                                            {row.d_width} x {row.d_length}
                                                                        </TableCell>

                                                                        <TableCell sx={{ textAlign: "right" }}>{row.quantity}</TableCell>
                                                                        <TableCell sx={{ textAlign: 'center' }}>

                                                                            <Tooltip title='Child-Reel Convertion Status'>

                                                                                <Box
                                                                                    component="span"
                                                                                    sx={{
                                                                                        display: 'inline-block',
                                                                                        px: 2,
                                                                                        py: 0.4,
                                                                                        borderRadius: '16px',  // more pill-like
                                                                                        bgcolor: '#1C7DE7',   // exact blue from image
                                                                                        color: 'white',
                                                                                        fontWeight: 'normal',
                                                                                        fontSize: '0.8rem',
                                                                                        textTransform: 'none', // lowercase
                                                                                        textAlign: 'center',
                                                                                        fontFamily: 'Roboto, sans-serif', // consistent with MUI default
                                                                                    }}
                                                                                >
                                                                                    {row.status}
                                                                                </Box>
                                                                            </Tooltip>
                                                                        </TableCell>



                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CustomTableContainer>

                                            </Grid>
                                        </Grid>

                                        <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Divider />
                                            </Grid>
                                        </Grid>




                                        <Grid container padding="20px 0px 3px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>



                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: 1.5 }}>
                                                    <Typography variant="body1" color="text.secondary" fontWeight={600}>
                                                        {selectedRows.length > 0
                                                            ? `${selectedRows.length} child reel${selectedRows.length !== 1 ? "s" : ""} selected`
                                                            : "No child reels selected"}
                                                    </Typography>

                                                    <Button
                                                        endIcon={<DoubleArrowRounded />}
                                                        onClick={LoadSelectedLineItemList}
                                                        sx={{
                                                            textTransform: 'none',
                                                            borderRadius: 3,
                                                            px: 2,
                                                            py: 0.5,
                                                            fontWeight: 500,
                                                            fontSize: '0.75rem',   // increase font size here
                                                        }}
                                                        variant="contained"
                                                        color="secondary"
                                                        size="small"
                                                        disabled={selectedRows.length === 0}
                                                    >
                                                        Proceed to Next
                                                    </Button>








                                                </Box>
                                            </Grid>
                                        </Grid>

                                        {/* selected reel list */}






                                    </>
                                ) : (
                                    <>
                                        {viewSheeterchildRollDetail === false ? (
                                            <>
                                                <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <CustomTableContainer colors={colors}>
                                                            <TableContainer >

                                                                {loadingOrderItemDet ? (
                                                                    <SkeletonTableLoader rows={5} columns={11} />
                                                                ) : (
                                                                    <Table stickyHeader size="small" >
                                                                        <TableHead sx={{ height: 10 }}>
                                                                            <TableRow>
                                                                                <TableCell>S.No</TableCell>

                                                                                <TableCell sx={{ textAlign: "center" }}>CO DATE</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>CO NUMBER</TableCell>
                                                                                {/* <TableCell sx={{ textAlign: "center", width: '180px' }}>CHILD ROLL NUMBER</TableCell> */}
                                                                                <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>SIZE</TableCell>

                                                                                <TableCell sx={{ textAlign: "center" }}>PRODUCED REELS</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>ACH.QTY</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>PRODUCED QTY</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>BALANCE QTY</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>PRODUCED SHEETS</TableCell>
                                                                                <TableCell sx={{ textAlign: "center" }}>PRODUCED PALLETS</TableCell>
                                                                                <TableCell>Action</TableCell>

                                                                                <TableCell >
                                                                                    <IconButton >

                                                                                        <Searchicon style={{ fontSize: "16px" }} onClick={handleOpen} />
                                                                                    </IconButton>
                                                                                    <Modal
                                                                                        open={open}
                                                                                        onClose={handleClose}
                                                                                        aria-labelledby="modal-modal-title"
                                                                                        aria-describedby="modal-modal-description"
                                                                                    >
                                                                                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: colors.primary[600], boxShadow: 24, p: 4, minWidth: 300 }}>
                                                                                            <TextField
                                                                                                label="CO Number"
                                                                                                name="indent_no"
                                                                                                value={filters.indent_no}
                                                                                                onChange={handleFilterChange}
                                                                                                variant="outlined"
                                                                                                fullWidth
                                                                                                size="small"
                                                                                                margin="normal"
                                                                                            />
                                                                                            <TextField
                                                                                                label="Child Roll Number"
                                                                                                name="cr_number"
                                                                                                value={filters.cr_number}
                                                                                                onChange={handleFilterChange}
                                                                                                variant="outlined"
                                                                                                fullWidth
                                                                                                size="small"
                                                                                                margin="normal"
                                                                                            />

                                                                                            <Button variant="contained" style={{ marginTop: 10 }}>
                                                                                                {/* onClick={handleClose}  */}
                                                                                                Apply Filter
                                                                                            </Button>
                                                                                        </Box>
                                                                                    </Modal>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {filteredData.map((row, index) => (
                                                                                <>
                                                                                    <React.Fragment key={row.indent_no}>
                                                                                        <TableRow key={row.id}>
                                                                                            <TableCell sx={{ textAlign: "center" }}>{index + 1}</TableCell> {/* Sequence Number */}
                                                                                            <TableCell sx={{ textAlign: "center" }}>{row.indent_date}</TableCell>
                                                                                            <TableCell sx={{ textAlign: "left", fontWeight: "bold" }}>
                                                                                                <span
                                                                                                    style={{ color: '#039be5', textDecoration: 'underline', cursor: 'pointer' }}
                                                                                                    onClick={() => handleCallEdit(row.indent_no, row.line_no)}
                                                                                                >
                                                                                                    {/* {row.indent_no} / {row.line_no} */}{row.indent_no}
                                                                                                </span>
                                                                                            </TableCell>
                                                                                            {/* <TableCell sx={{ textAlign: "left" }}>{row.customer_name}</TableCell>
                                                                                <TableCell sx={{ textAlign: "left" }}>{row.supplier_name}</TableCell> */}
                                                                                            {/* <TableCell sx={{ textAlign: "left", width: "260px" }}>{row.cr_number}</TableCell> */}
                                                                                            <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                                            <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                                            <TableCell sx={{ textAlign: "center" }}>{row.d_width} x {row.d_length}</TableCell>
                                                                                            {/* <TableCell sx={{ textAlign: "right" }}></TableCell> */}
                                                                                            <TableCell sx={{ textAlign: "right" }}>{row.reel_count}</TableCell>
                                                                                            <TableCell sx={{ textAlign: "right" }}>{row.total_qty}</TableCell>
                                                                                            <TableCell sx={{ textAlign: "right" }}>{row.plannedqty}</TableCell>
                                                                                            <TableCell sx={{ textAlign: "right" }}>{row.balanceqty}</TableCell>
                                                                                            <TableCell sx={{ textAlign: "right" }}>{row.sheets_count}</TableCell>
                                                                                            <TableCell sx={{ textAlign: "right" }}>{row.pallet_count}</TableCell>
                                                                                            <TableCell>
                                                                                                <Tooltip title="View child roll wise production">
                                                                                                    <IconButton onClick={() => handleExpandRow(row)}>
                                                                                                        {expandedRow === row.indent_no ? <ExpandLess style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} /> : <ExpandMore style={{ color: 'teal', fontSize: "16px", fontWeight: "bold" }} />}
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                            </TableCell>
                                                                                        </TableRow>

                                                                                        {/* Expanded Row */}
                                                                                        {expandedRow === row.indent_no && (
                                                                                            <TableRow>
                                                                                                <TableCell colSpan={8}>
                                                                                                    <Collapse in={expandedRow === row.indent_no} timeout="auto" unmountOnExit>
                                                                                                        <Box margin={1}>
                                                                                                            {/* Expanded Data in Table Format */}
                                                                                                            {expandedData[row.indent_no] ? (
                                                                                                                <Table size="small" aria-label="expanded-data">
                                                                                                                    <TableHead>
                                                                                                                        <TableRow>
                                                                                                                            <TableCell></TableCell>
                                                                                                                            <TableCell>CHILD ROLL NUMBER</TableCell>
                                                                                                                            <TableCell sx={{ textAlign: "center", }}>ACH.QTY</TableCell>
                                                                                                                            <TableCell sx={{ textAlign: "center", }}>PRODUCED QTY</TableCell>
                                                                                                                            <TableCell sx={{ textAlign: "center", }}>BALANCE QTY</TableCell>
                                                                                                                            <TableCell sx={{ textAlign: "center", }}>PRODUCED SHEETS</TableCell>
                                                                                                                        </TableRow>
                                                                                                                    </TableHead>
                                                                                                                    <TableBody>
                                                                                                                        {expandedData[row.indent_no].map((item, index) => (
                                                                                                                            <TableRow key={index}>
                                                                                                                                <TableCell>{index + 1}</TableCell>
                                                                                                                                <TableCell>{item.cr_number}</TableCell>
                                                                                                                                <TableCell sx={{ textAlign: "right" }}>{item.total_qty}</TableCell>
                                                                                                                                <TableCell sx={{ textAlign: "right" }}>{item.plannedqty}</TableCell>
                                                                                                                                <TableCell sx={{ textAlign: "right" }}>{item.balanceqty}</TableCell>
                                                                                                                                <TableCell sx={{ textAlign: "right" }}>{item.sheets_count}</TableCell>
                                                                                                                            </TableRow>
                                                                                                                        ))}
                                                                                                                    </TableBody>
                                                                                                                </Table>
                                                                                                            ) : (
                                                                                                                "Loading..."
                                                                                                            )}
                                                                                                        </Box>
                                                                                                    </Collapse>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                </>


                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                )}


                                                                {loading && (

                                                                    <Box
                                                                        sx={{
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            alignItems: 'center',
                                                                            height: '150px', // Adjust the height as needed
                                                                            marginTop: '40px',
                                                                        }}
                                                                    >
                                                                        <CircularProgress
                                                                            size={40} // Adjust size of the CircularProgress
                                                                            thickness={4} // Adjust thickness of the CircularProgress
                                                                            sx={{
                                                                                color: '#039be5', // Set the desired color
                                                                            }}
                                                                        />

                                                                        {/* <img
                                                                                                                                src={process.env.PUBLIC_URL + '/OptrimLogo1.png'}
                                                                                                                                alt="Logo"
                                                                                                                                style={{
                                                                                                                                    position: "absolute",
                                                                                                                                    width: 30,
                                                                                                                                    height: 30,
                                                                                                                                    borderRadius: "50%",
                                                                                                                                }}
                                                                                                                            /> */}
                                                                    </Box>
                                                                )}
                                                            </TableContainer>
                                                        </CustomTableContainer>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        ) : (null)}

                                    </>
                                )}

                            </Grid>
                        </Box>
                    </>) : (null)}



                    <Box
                        sx={{
                            // backgroundColor: colors.primary[700],
                            padding: "10px",
                            borderRadius: "10px",
                            marginTop: "10px",
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '76vh', // Large devices (desktops)
                                xl: '82vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}>

                        {viewSheeterchildRollDetail && (
                            <div>
                                {jobID > 0 && (
                                    <Grid container padding="1px 0px 10px 5px" sx={{ backgroundColor: colors.primary[400], borderRadius: "0px" }} spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left" marginLeft={2}>
                                                Job Number
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={11} md={3.8} lg={6} xl={6}>
                                            <TextField size="small" value={jobID} />
                                        </Grid>

                                    </Grid>
                                )}

                                <Box sx={{ backgroundColor: colors.primary[500], marginTop: "10px", borderRadius: "2px" }}>
                                    <Grid mt={0} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                                        <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={1.6} lg={9} xl={9} display="flex-start" justifyContent="center">
                                                <Box
                                                    sx={{
                                                        display: 'inline-flex',
                                                        borderBottom: '2px solid #ec407a'  // Underline color
                                                    }}
                                                >
                                                    <Typography variant="h5" marginLeft="0px" padding="3px" marginTop={0} textAlign="left" >
                                                        Planning Details
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.6} lg={3} xl={3} display="flex" marginRight="auto" justifyContent="center">
                                                <Typography variant="h6" marginLeft="auto" >Available Sheets count: {totalReelSheets}</Typography>
                                            </Grid>
                                        </Grid>
                                        {/* <Divider sx={{ marginBottom: "20px" }} /> */}

                                        <Grid container padding="1px 0px 5px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6">{t('prod_sheet_convertion.shift_code')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={winderShiftCode}
                                                    onChange={handleWinderShiftChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={shiftCodes}
                                                    getOptionLabel={(option) => `${option.shiftcode}`}
                                                    renderInput={(params) =>
                                                        <TextField required
                                                            helperText={errorMessage}
                                                            error={errorMessage && errorMessage.length ? true : false}
                                                            {...params} variant="outlined" />}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_sheet_convertion.shift_date_time')}</Typography>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                                <FormControl fullWidth size="small">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <Stack spacing={1} >
                                                            <DatePicker
                                                                // label="Today Date"
                                                                format="DD-MMM-YYYY"
                                                                value={dayjs(shiftDate)}
                                                                onChange={(date) => setShiftDate(date)}
                                                                slotProps={{ textField: { size: 'small' } }}
                                                                fullWidth
                                                                disabled={jobID > 0 ? true : false}
                                                                renderInput={(props) => (
                                                                    <TextField
                                                                        disabled={jobID > 0 ? true : false}
                                                                        helperText={shiftdate_errorMessage}
                                                                        error={shiftdate_errorMessage && shiftdate_errorMessage.length ? true : false}
                                                                        {...props} />
                                                                )}
                                                            />
                                                        </Stack>
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                <Typography variant="h6" marginLeft={1}>{t('prod_sheet_convertion.winder_operator')}</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={selectedOperator}
                                                    onChange={handleOperatorChange}
                                                    size="small"
                                                    style={{ fontSize: '12px' }}
                                                    options={operator}
                                                    getOptionLabel={(option) => `${option.operator_code}`}
                                                    renderInput={(params) =>
                                                        <TextField required
                                                            {...params} variant="outlined" />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" marginTop={0} textAlign="left">
                                                Sheeter Machine
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                                            <Stack direction="row" spacing={1}>
                                                <Autocomplete
                                                    fullWidth
                                                    value={selectedCutterCodes}
                                                    onChange={handleSelectCuttercode}
                                                    size="small"
                                                    options={cutterCodes}
                                                    getOptionLabel={(option) => `${option.cutter_code} `} // Assuming lot numbers are strings
                                                    renderInput={(params) => <TextField {...params} placeholder="Select cutter" variant="outlined" />}
                                                />
                                            </Stack>
                                        </Grid>

                                        {/* <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" marginLeft={1}>{t('prod_sheet_convertion.actual_produced_no_of_sheets')}</Typography>
                                        </Grid> */}
                                        {/* 
                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <TextField
                                                fullWidth
                                                disabled={disableNumberofSheets}
                                                size="small"
                                                required
                                                type='number'
                                                value={actualNoOfSheetsProduced} onChange={handleChange} // Update state on change
                                            />
                                        </Grid> */}

                                        <Grid item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" marginLeft={1}>{t('prod_sheet_convertion.no_of_sheets')}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2} display="flex-start" justifyContent="center">
                                            <TextField
                                                fullWidth
                                                size="small"
                                                required
                                                type='number'
                                                disabled={jobID > 0 ? true : false}
                                                InputProps={{
                                                    inputProps: { style: { textAlign: 'right' } }
                                                }}
                                                value={sheeterNoOfSheets} onChange={CalculatePalletValue}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1} lg={0.5} xl={1} display="flex-start" justifyContent="center">
                                            <Typography variant="h6" marginLeft={1}>{t('prod_reams.fno')}</Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={2} lg={1} xl={2} display="flex-start" justifyContent="center">
                                            <TextField
                                                fullWidth
                                                disabled={disableNumberofSheets}
                                                size="small"
                                                required
                                                type='number'
                                                InputProps={{
                                                    inputProps: { style: { textAlign: 'right' } }
                                                }}
                                                value={fNo}
                                                onChange={(e) => setFNo(e.target.value)}
                                            // onChange={CalculatePalletValue}
                                            />
                                        </Grid>


                                        <FormControlLabel sx={{ ml: '4px' }}
                                            disabled={disabledLooseBundleOption}
                                            control={<Checkbox color="secondary" size="small" checked={checked} onChange={handleUseLoosePallete} />}
                                            label="Create Pallets merge with Loose Pallets"
                                        />

                                    </Grid>

                                </Box>

                                <Divider sx={{ marginTop: "0px" }} />
                                <Grid mt={1} item xs={12} sm={12} md={12} lg={12} xl={12}   >
                                    <Grid container >
                                        <Grid item xs={12} sm={12} md={5} lg={12} xl={10} display="flex-start" >
                                            <Box sx={{ padding: 3 }}>


                                                <Box
                                                    mb={2}
                                                    sx={{
                                                        display: 'inline-flex',
                                                        borderBottom: '2px solid #ec407a'  // Underline color
                                                    }}
                                                >
                                                    <Typography variant="h5" marginLeft="0px" padding="3px" marginTop={0} textAlign="left" >
                                                        Child Reel-wise Sheet Production
                                                    </Typography>
                                                </Box>



                                                {/* {selectedReelList.map((reel) => {
                                                    const existingSheetCount = sheetCounts.find(item => item.id_reel === reel.id_reel)?.sheetCount || "";
                                                    const data = reelFormData.find(item => item.id_reel === reel.id_reel) || {};

                                                    return (
                                                        <Grid
                                                            key={reel.id_reel}
                                                            container
                                                            alignItems="center"
                                                            spacing={2}
                                                            sx={{ marginBottom: 3 }}
                                                        >
                                                            <Grid item lg={1.5}>
                                                                <Typography variant="body1" textAlign="left">
                                                                    Reel No: {reel.code}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item lg={2}>

                                                                <TextField
                                                                    size="small"
                                                                    label="No of sheets"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    type="number"
                                                                    disabled={disableReelWiseSheetInput}
                                                                    value={existingSheetCount}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;

                                                                        if (value >= 0 || value === "") {
                                                                            handleInputChange(reel.id_reel, value);
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {

                                                                        if (e.key === "-" || e.key === "e") {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onWheel={(e) => {

                                                                        e.preventDefault();
                                                                    }}

                                                                    InputProps={{
                                                                        inputProps: { style: { textAlign: 'right' } }
                                                                    }}
                                                                />

                                                            </Grid>

                                                          
                                                            <Grid item lg={2}>
                                                                <TextField
                                                                    size="small"
                                                                    label="Repulp qty"
                                                                    type="number"
                                                                    fullWidth
                                                                    value={data.repulp_qty}
                                                                    onChange={e => {
                                                                        const val = e.target.value;
                                                                        if (val === "" || (+val >= 0 && Number.isInteger(+val))) {
                                                                            updateReelField(reel.id_reel, "repulp_qty", val);
                                                                        }
                                                                    }}
                                                                    onKeyDown={e => (e.key === "-" || e.key === "e") && e.preventDefault()}
                                                                    onWheel={e => e.preventDefault()}

                                                                    InputProps={{
                                                                        inputProps: { style: { textAlign: 'right' } }
                                                                    }}
                                                                />
                                                            </Grid>

                                                          
                                                            <Grid item lg={2}>


                                                                <Autocomplete
                                                                    size="small"
                                                                    options={["G1", "SL", "Repulp"]}
                                                                    value={data.grade || ""}
                                                                    onChange={(_, newVal) => updateReelField(reel.id_reel, "grade", newVal)}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="Grade"
                                                                            fullWidth
                                                                            sx={{ "& .MuiInputBase-input": { padding: "4px 8px" } }}
                                                                        />
                                                                    )}
                                                                />

                                                            </Grid>

                                                          
                                                            <Grid item lg={4.5}>
                                                                <TextField
                                                                    size="small"
                                                                    label="Remarks"
                                                                    fullWidth

                                                                    value={data.remarks}
                                                                    onChange={e => updateReelField(reel.id_reel, "remarks", e.target.value)}
                                                                />
                                                            </Grid>
                                                        </Grid>);
                                                })} */}
                                                <CustomTableContainer colors={colors}>
                                                    <TableContainer >
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Child Reel Number</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>No of Sheets</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }} >Grade</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Repulp Qty</TableCell>
                                                                    <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Remarks</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {selectedReelList.map((reel) => {
                                                                    const existingSheetCount = sheetCounts.find(item => item.id_reel === reel.id_reel)?.sheetCount || "";
                                                                    const data = reelFormData.find(item => item.id_reel === reel.id_reel) || {};

                                                                    return (
                                                                        <TableRow key={reel.id_reel}>
                                                                            {/* Reel No */}
                                                                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>{reel.code}</TableCell>

                                                                            {/* No of Sheets */}
                                                                            <TableCell align="right">
                                                                                <TextField
                                                                                    size="small"
                                                                                    type="number"
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    disabled={disableReelWiseSheetInput}
                                                                                    value={existingSheetCount}
                                                                                    onChange={(e) => {
                                                                                        const value = e.target.value;
                                                                                        if (value >= 0 || value === "") {
                                                                                            handleInputChange(reel.id_reel, value);
                                                                                            updateReelField(reel.id_reel, "sheetCount", value);
                                                                                        }
                                                                                    }}
                                                                                    onKeyDown={(e) => (e.key === "-" || e.key === "e") && e.preventDefault()}
                                                                                    onWheel={(e) => e.preventDefault()}
                                                                                    InputProps={{
                                                                                        inputProps: { style: { textAlign: 'right' } }
                                                                                    }}
                                                                                    sx={{
                                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                                            border: 'none',
                                                                                        },
                                                                                        '& .MuiInputBase-input': {
                                                                                            padding: '8px',
                                                                                            textAlign: 'center',
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            </TableCell>

                                                                            {/* Grade */}
                                                                            <TableCell>
                                                                                <Autocomplete
                                                                                    size="small"
                                                                                    options={["G1", "SL", "Repulp"]}
                                                                                    value={data.grade || ""}
                                                                                    onChange={(_, newVal) => updateReelField(reel.id_reel, "grade", newVal)}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            fullWidth

                                                                                            sx={{
                                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                                    border: 'none',
                                                                                                },
                                                                                                '& .MuiInputBase-input': {
                                                                                                    padding: '8px',

                                                                                                },
                                                                                            }}


                                                                                        />
                                                                                    )}

                                                                                />
                                                                            </TableCell>

                                                                            {/* Repulp Qty */}
                                                                            <TableCell align="right">
                                                                                <TextField
                                                                                    size="small"
                                                                                    type="number"
                                                                                    fullWidth

                                                                                    value={data.repulp_qty}
                                                                                    onChange={e => {
                                                                                        const val = e.target.value;
                                                                                        if (val === "" || (!isNaN(val) && parseFloat(val) >= 0)) {
                                                                                            updateReelField(reel.id_reel, "repulp_qty", val);
                                                                                        }
                                                                                    }}
                                                                                    onKeyDown={e => {
                                                                                        // prevent minus or "e"
                                                                                        if (e.key === "-" || e.key === "e") {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    onWheel={e => e.preventDefault()}
                                                                                    InputProps={{
                                                                                        inputProps: { style: { textAlign: 'right', min: 0 } }
                                                                                    }}
                                                                                    sx={{
                                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                                            border: 'none',
                                                                                        },
                                                                                        '& .MuiInputBase-input': {
                                                                                            padding: '8px',
                                                                                            textAlign: 'center',
                                                                                        },
                                                                                    }}
                                                                                />

                                                                            </TableCell>



                                                                            {/* Remarks */}
                                                                            <TableCell>
                                                                                {/* <TextField
                                                                                    size="small"
                                                                                    fullWidth
                                                                                    value={data.remarks}
                                                                                    onChange={e => updateReelField(reel.id_reel, "remarks", e.target.value)}
                                                                                    sx={{
                                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                                            border: 'none',
                                                                                        },
                                                                                        '& .MuiInputBase-input': {
                                                                                            padding: '8px',

                                                                                        },
                                                                                    }}
                                                                                /> */}


                                                                                <Box display="flex" alignItems="center">
                                                                                    <Autocomplete
                                                                                        size="small"
                                                                                        fullWidth
                                                                                        loading={loadingRemarks}
                                                                                        options={remarkOptions}   // full objects from API
                                                                                        getOptionLabel={(option) => option?.description || ""}  // 👈 show only description
                                                                                        // value={data.remarks || ""}  
                                                                                        value={remarkOptions.find(opt => opt.description === data.remarks) || null}
                                                                                        onChange={(_, newVal) => updateReelField(reel.id_reel, "remarks", newVal.description)}
                                                                                        renderInput={(params) => (
                                                                                            <TextField {...params} variant="outlined" />
                                                                                        )}
                                                                                    />

                                                                                    <Tooltip title="Add New Remark">
                                                                                        <IconButton
                                                                                            onClick={handleOpenAddRemark}
                                                                                            size="small"
                                                                                            sx={{ ml: 1 }}
                                                                                        >
                                                                                            <AddCircleOutlineIcon color="secondary" />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </Box>


                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer></CustomTableContainer>





                                                <Box sx={{ marginTop: 1 }}>
                                                    <Typography variant="h6">
                                                        Total Sheets Produced :
                                                        <Typography
                                                            component="span"
                                                            variant="h5"
                                                            fontWeight="bold"
                                                            sx={{ marginLeft: 1 }}
                                                        >
                                                            {actualNoOfSheetsProduced}
                                                        </Typography>
                                                    </Typography>

                                                </Box>
                                                {/* <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{ marginTop: 2 }}
                                      
                                    >
                                        Submit
                                    </Button> */}
                                            </Box>
                                        </Grid>




                                    </Grid>
                                </Grid>


                                {checked && (
                                    <>
                                        <Divider sx={{ marginTop: "0px" }} />
                                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>

                                            <Box sx={{ padding: 3 }}>
                                                <Typography sx={{
                                                    display: 'inline-flex',
                                                    borderBottom: '2px solid #ec407a'  // Underline color
                                                }} variant="h5" gutterBottom mb={2}>
                                                    Loose Pallet Details
                                                </Typography>

                                                <CustomTableContainer colors={colors}>
                                                    <TableContainer size="small">
                                                        <Table size="small" stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Select</TableCell>
                                                                    <TableCell>Pallet Code</TableCell>
                                                                    <TableCell>Size</TableCell>
                                                                    <TableCell>Sheets</TableCell>
                                                                    <TableCell>Weight (kg)</TableCell>
                                                                    <TableCell>Child Reel No</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {loosepalletDet.map((row) => (
                                                                    <TableRow key={row.id_pallet}>
                                                                        <TableCell>

                                                                            <Checkbox
                                                                                checked={selectedPallet.length > 0 && selectedPallet[0].id_pallet === row.id_pallet}
                                                                                size="small"
                                                                                onChange={() => handleSelect(row)}
                                                                                color="secondary"
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell>{row.pallet_code}</TableCell>
                                                                        <TableCell>{row.pallet_size}</TableCell>
                                                                        <TableCell>{row.number_of_sheets}</TableCell>
                                                                        <TableCell>{row.pallet_weight}</TableCell>
                                                                        <TableCell>{row.cr_number}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CustomTableContainer>
                                            </Box>
                                        </Grid>
                                    </>
                                )}


                                <Divider sx={{ marginTop: "10px" }} />




                                {sheeterNoOfSheets !== 0 && (

                                    <Grid container padding="10px 0px 5px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                        <Grid item xs={11} sm={11} md={10} lg={11.9} xl={11.9} display="flex-start" justifyContent="center">

                                            <Grid container padding="5px 5px 5px 10px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                <Grid item md={0} ml="5px" mr="5px">
                                                    <Tooltip title="Back to Line item wise achieved reams ">
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <Typography variant="h6">{t('prod_sheet_convertion.total_pallet')}</Typography>
                                                            <Typography variant="h4" fontWeight="bold">{sheeterTotalPallet || 0}</Typography>
                                                        </div>
                                                    </Tooltip>
                                                </Grid>
                                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

                                                <Grid item md={0} ml="5px" mr="5px">
                                                    <Tooltip title="Back to Line item wise achieved reams ">
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <Typography variant="h6">{t('prod_sheet_convertion.total_lose_pallet')}</Typography>
                                                            <Typography variant="h4" fontWeight="bold">{sheeterTotalLPallet || 0}</Typography>
                                                        </div>
                                                    </Tooltip>
                                                </Grid>
                                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

                                                <Grid item md={0} ml="5px" mr="5px">
                                                    <Tooltip title="Back to Line item wise achieved reams ">
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <Typography variant="h6">{t('prod_sheet_convertion.pallet_weight')}</Typography>
                                                            <Typography variant="h4" fontWeight="bold">{sheeterPalletWeight || 0}</Typography>
                                                        </div>
                                                    </Tooltip>
                                                </Grid>
                                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

                                                <Grid item md={0} ml="5px" mr="5px">
                                                    <Tooltip title="Back to Line item wise achieved reams ">
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <Typography variant="h6">{t('prod_sheet_convertion.balance_weight')}</Typography>
                                                            <Typography variant="h4" fontWeight="bold">{sheeterBalanceWeight || 0}</Typography>
                                                        </div>
                                                    </Tooltip>
                                                </Grid>
                                                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2.5px" }} />





                                                {jobID === 0 && (
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                            <Button disabled={disableProceedBtn} onClick={() => updatePalletRollDetails(0)} variant="contained" color="secondary" size="medium">Proceed</Button>
                                                        </Box>
                                                    </Grid>
                                                )}

                                                {jobID > 0 && (
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                                        <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                            {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Update") && (
                                                                <Button
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    size="small"
                                                                    startIcon={<EditIcon />}
                                                                    sx={{ mr: 1, textTransform: 'none' }}
                                                                    onClick={() => updatePalletRollDetails(1)}
                                                                >
                                                                    Update
                                                                </Button>
                                                            )}


                                                            {/* <Button
                                                                size="small"
                                                                variant="contained"
                                                                startIcon={<DeleteForeverOutlinedIcon />}
                                                                sx={{
                                                                    backgroundColor: 'lightcoral',
                                                                }}
                                                                onClick={DeletePalletProductionJobDetails}
                                                            >
                                                                Delete
                                                            </Button> */}
                                                            {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Delete") && (
                                                                <DeleteButton onClick={DeletePalletProductionJobDetails} label="Delete" />
                                                            )}

                                                        </Box>



                                                    </Grid>
                                                )}
                                            </Grid>


                                        </Grid>
                                    </Grid>
                                )}
                            </div>)}


                        {/* // view QR Code Details */}
                        {viewSheeterQRcode && (
                            <div>
                                {/* <Box sx={{ backgroundColor: colors.primary[400], marginTop: "1px", border: "1px solid ", borderColor: colors.primary[300], borderRadius: "2px" }}> */}
                                <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid mt={2} mb={0.5} item xs={12} sm={12} md={1.6} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                        <Typography variant="h5" fontWeight="bold" marginTop={0} textAlign="left">
                                            Pallet List
                                        </Typography>
                                    </Grid>

                                </Grid>

                                {/* </Box> */}
                                <Divider sx={{ marginTop: "10px" }} />

                                <Grid container padding="1px 0px 10px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item xs={11} sm={11} md={11} lg={6} xl={5} display="flex-start" justifyContent="center">

                                        <CustomTableContainer colors={colors}>
                                            <TableContainer >
                                                <Table size="small">
                                                    <TableHead sx={{ height: 10 }}>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Checkbox size="small" sx={{

                                                                    color: 'secondary' // Custom color
                                                                }}
                                                                    indeterminate={selectedPalletRows.length > 0 && selectedPalletRows.length < filteredPalletData.length}
                                                                    checked={selectedPalletRows.length === filteredPalletData.length}
                                                                    onChange={handleSelectAllClickPallet}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ textAlign: "center" }}>PALLET CODE</TableCell>
                                                            <TableCell sx={{ textAlign: "center" }}>NUMBER OF SHEETS</TableCell>
                                                            <TableCell sx={{ textAlign: "center" }}>PALLET WEIGHT</TableCell>
                                                            <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    {/* <TableBody>
                                                        {palletList.map((row) => (
                                                            <TableRow key={row.pallet_id} >
                                                                <TableCell>
                                                                    <Checkbox
                                                                         size="small"
                                                                        sx={{
                                                                          
                                                                            color: 'secondary' // Custom color
                                                                        }}
                                                                        checked={isSelectedPallet(row.pallet_id)}
                                                                        disabled={row.status === 'converted'}
                                                                        onChange={(event) => handleRowCheckboxClickPallet(event, row.pallet_id)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ textAlign: "left" }}>{row.pallet_code}</TableCell>
                                                                <TableCell sx={{ textAlign: "right" }}>{row.no_of_sheets}</TableCell>
                                                                <TableCell sx={{ textAlign: "right" }}>{row.pallet_weight}</TableCell>


                                                                <Chip
                                                                    label={row.pr_status}
                                                                    variant="filled"
                                                                    size="small"
                                                                    sx={{
                                                                        // fontWeight: "bold",
                                                                        textTransform: "capitalize",
                                                                        color: "#fff",
                                                                        background: row.pr_status === "approved"
                                                                            ? "linear-gradient(45deg, #388e3c, #2e7d32)"
                                                                            : "linear-gradient(45deg, #00838f, #0097a7)",
                                                                        boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
                                                                        transition: "transform 0.2s ease-in-out",
                                                                        // "&:hover": {
                                                                        //   transform: "scale(1.1)",
                                                                        //   boxShadow: "0 5px 8px rgba(0, 0, 0, 0.3)"
                                                                        // },
                                                                    }}
                                                                />
                                                            </TableRow>
                                                        ))}
                                                    </TableBody> */}

                                                    <TableBody>
                                                        {palletList.map((row) => {
                                                            const isChecked = isSelectedPallet(row.pallet_id);
                                                            const isDisabled = row.status === "converted";

                                                            return (
                                                                <TableRow
                                                                    key={row.pallet_id}
                                                                    hover
                                                                    sx={{
                                                                        cursor: isDisabled ? "not-allowed" : "pointer",
                                                                        opacity: isDisabled ? 0.6 : 1,
                                                                    }}
                                                                    onClick={() => {
                                                                        if (!isDisabled) {
                                                                            handleRowCheckboxClickPallet(null, row.pallet_id);
                                                                        }
                                                                    }}
                                                                >
                                                                    <TableCell onClick={(e) => e.stopPropagation()}>
                                                                        <Checkbox
                                                                            size="small"
                                                                            sx={{ color: "secondary" }}
                                                                            checked={isChecked}
                                                                            disabled={isDisabled}
                                                                            onChange={(event) =>
                                                                                handleRowCheckboxClickPallet(event, row.pallet_id)
                                                                            }
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: "left" }}>
                                                                        {row.pallet_code}
                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: "right" }}>
                                                                        {row.no_of_sheets}
                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: "right" }}>
                                                                        {row.pallet_weight}
                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: "center" }}>
                                                                        <Chip
                                                                            label={row.pr_status}
                                                                            size="small"
                                                                            sx={{
                                                                                color: "#fff",
                                                                                textTransform: "capitalize",
                                                                                background:
                                                                                    row.pr_status === "approved"
                                                                                        ? "linear-gradient(45deg, #388e3c, #2e7d32)"
                                                                                        : "linear-gradient(45deg, #00838f, #0097a7)",
                                                                            }}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>

                                                </Table>
                                            </TableContainer>
                                        </CustomTableContainer>

                                    </Grid>
                                </Grid>

                                <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Box sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>
                                        <Toolbar>
                                            {hasPermission(userPermissions, "Cutter Sheeter Convertion", "View") && (
                                                <Button type="submit" onClick={() => viewQRCode()} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ textTransform: 'none' }}>{t('prod_sheet_convertion.btn_view_qr')}</Button>

                                            )}
                                            {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Print") && (
                                                <Button type="submit" onClick={() => handleButtonClick('PrintQRAll')} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ marginLeft: '10px', textTransform: 'none' }}>{t('prod_sheet_convertion.btn_print_qr')}</Button>
                                            )}

                                            {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Print") && (
                                                <Button type="submit" onClick={() => handlePrintReamQRCodeButtonClick('PrintQRAll')} size="small" variant="contained" color="secondary" startIcon={<QrCode2RoundedIcon />} sx={{ marginLeft: '10px', textTransform: 'none' }}>{t('prod_sheet_convertion.btn_print_ream_qr')}</Button>
                                            )}
                                            {jobID > 0 && (
                                                <>
                                                    {hasPermission(userPermissions, "Cutter Sheeter Convertion", "Delete") && (
                                                        <DeleteButton onClick={DeleteSelectedPalletsProductionJobDetails} label="Delete" sx={{ marginLeft: '10px' }} />
                                                    )}
                                                </>
                                            )}
                                        </Toolbar>
                                    </Box>
                                </Grid>

                                <Divider sx={{ marginTop: "10px" }} />

                                <Grid container padding="0px 0px 0px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                                    <Grid item mt={1} sm={11} md={11} lg={8} xl={6} >
                                        <div>
                                            <LabelPalletDetails qrCodeValue={qrCodeValue} ProductDetail={selectedPalletDetails} />
                                        </div>
                                    </Grid>
                                </Grid>

                                <Grid container padding="5px 0px 0px 5px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"  >
                                    <Grid item xs={11} sm={11} md={11} lg={12} xl={12} display="flex-start" justifyContent="center" marginBottom="auto">
                                        <Accordion   >
                                            {/*sx={{ backgroundColor: colors.primary[500] }} */}
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon sx={{ fontSize: "0.875rem" }} />}
                                                sx={{
                                                    minHeight: "28px", // Smaller height for compactness
                                                    padding: "0 8px", // Reduced padding
                                                    // backgroundColor: colors.primary[400],
                                                    borderRadius: "2px",
                                                    "& .MuiAccordionSummary-content": {
                                                        margin: 0,
                                                        fontSize: "0.75rem", // Smaller font for a compact appearance
                                                        fontWeight: "bold",
                                                    },
                                                    "&.Mui-expanded": {
                                                        minHeight: "24px", // Keeps the header thin even when expanded
                                                    },
                                                }}
                                            >
                                                <Box display="flex" alignItems="center">
                                                    {/* Add the icon here */}
                                                    <InfoIcon sx={{ marginRight: '4px', fontSize: 16, color: colors.blueAccent[500] }} />
                                                    <Typography variant="subtitle2">View Selected Child Rolls</Typography>
                                                </Box>
                                            </AccordionSummary>
                                            <AccordionDetails>

                                                <ResponsiveBox customMaxHeight={{
                                                    xs: '72vh', // Extra small devices (phones)
                                                    sm: '72vh', // Small devices (tablets)
                                                    md: '74vh', // Medium devices (small laptops)
                                                    lg: '30vh', // Large devices (desktops)
                                                    xl: '30vh', // Extra large devices (large desktops)
                                                }}>
                                                    <CustomTableContainer colors={colors}>
                                                        <TableContainer >
                                                            <Table size="small">
                                                                <TableHead sx={{ height: 10 }}>
                                                                    <TableRow>
                                                                        <TableCell sx={{ textAlign: "center" }}>CO NO</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>CHILD ROLL NUMBER</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>QUALITY</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>GSM</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>MASTER REEL</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>WIDTH</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>LENGTH</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>REEL WEIGHT</TableCell>
                                                                        <TableCell sx={{ textAlign: "center" }}>STATUS</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {selectedReelList.map((row) => (
                                                                        <TableRow key={row.id_reel}>
                                                                            <TableCell sx={{ textAlign: "left" }}>{row.indent_no}</TableCell>
                                                                            <TableCell sx={{ textAlign: "left" }}>{row.code}</TableCell>
                                                                            <TableCell sx={{ textAlign: "left" }}>{row.item_code}</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>{row.gsm}</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>{row.master_reel}</TableCell>
                                                                            <TableCell sx={{ textAlign: "right" }}>{row.d_width}</TableCell>
                                                                            <TableCell sx={{ textAlign: "right" }}>{row.d_length}</TableCell>
                                                                            <TableCell sx={{ textAlign: "right" }}>{row.quantity}</TableCell>
                                                                            <TableCell sx={{ textAlign: "center" }}>{row.status}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </CustomTableContainer>
                                                </ResponsiveBox>

                                                {/* <Box
                                                    sx={{
                                                        borderRadius: "10px",
                                                        maxHeight: {
                                                            xs: '72vh', // Extra small devices (phones)
                                                            sm: '72vh', // Small devices (tablets)
                                                            md: '74vh', // Medium devices (small laptops)
                                                            lg: '30vh', // Large devices (desktops)
                                                            xl: '30vh', // Extra large devices (large desktops)
                                                        },
                                                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                                        '&::-webkit-scrollbar': {
                                                            width: '8px',
                                                        },
                                                        '&::-webkit-scrollbar-track': {
                                                            background: colors.primary[400],
                                                            borderRadius: '10px',
                                                        },
                                                        '&::-webkit-scrollbar-thumb': {
                                                            background: colors.blueAccent[600],
                                                            borderRadius: '10px',
                                                            '&:hover': {
                                                                background: colors.blueAccent[800],
                                                            },
                                                        },
                                                        '&::-webkit-scrollbar-corner': {
                                                            background: colors.primary[700],
                                                        }
                                                    }}>
                                                    <>
                                                        <Box
                                                            display="flex"
                                                            flexDirection="column"
                                                            alignItems="center"
                                                            padding={0.5}
                                                            sx={{
                                                                "& .MuiTable-root": {
                                                                    border: "none",
                                                                    size: "small",
                                                                },
                                                                "& .MuiTableCell-root": {
                                                                    borderBottom: "none",
                                                                    border: "1px solid",
                                                                    borderColor: `${colors.primary[100]} !important`,
                                                                },
                                                                "& .name-column--cell": {
                                                                    color: colors.greenAccent[300],
                                                                },
                                                                "& .MuiTableHead-root": {
                                                                    borderBottom: "none",
                                                                },
                                                                "& .MuiTableBody-root": {
                                                                    overflowY: "auto",
                                                                },
                                                                "& .MuiCheckbox-root": {
                                                                    color: `${colors.blueAccent[200]} !important`,
                                                                    size: "small",
                                                                },
                                                                "& .MuiTableFooter-root": {
                                                                    borderTop: "none",
                                                                    backgroundColor: colors.blueAccent[700],
                                                                    height: "10px",
                                                                },
                                                                "& .MuiButton-text": {
                                                                    color: `${colors.grey[100]} !important`,
                                                                },
                                                            }}
                                                        >

                                                        </Box>
                                                    </>
                                                </Box> */}
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                </Grid>



                            </div>
                        )}





                    </Box>



                </>
            )
            }


            {openAddRemark && (
                <AddRemarks open={openAddRemark} onClose={handleCloseAddRemark} moduleName={"Cutter Sheeter Convertion"} parentModuleName={"Production"} userPermissions={userPermissions} />
            )}
        </Box >

    );

};
export default SheeterConvertionProcess;